{
  "common": {
    "no_access": "Du har ikke adgang til dette modul"
  },
  "settings": {
    "calendar": {
      "calendar_settings": "Kalenderindstillinger",
      "settings": "Indstillinger",
      "select_calendar_type": "Vælg kalendertype",
      "add_new_calendar_group": "Tilføj ny kalendergruppe",
      "add_new_equipment": "Tilføj nyt udstyr",
      "new_calendar": "Ny kalender",
      "calendar_group_description": "Brug kalender Gruppe til effektivt at Sortere og Gruppe flere kalendere sammen.",
      "group": "Gruppe",
      "manage_your_calendars_and_groups": "Administrer dine kalendere og gruppe",
      "groups": "Grupper",
      "create_group": "Opret gruppe",
      "create_calendar": "Opret kalender",
      "calendar_name": "Kalenderens navn",
      "group_duration": "Gruppevarighed",
      "calendar_type": "Type",
      "action": "Handling",
      "round_robin": "Automatisk tildeling af aftaler",
      "event": "Begivenhed",
      "group_name": "Gruppenavn",
      "room_name": "Rumnavn",
      "group_description": "Gruppedescription",
      "calendar_url": "Kalender-URL",
      "calendars": "Kalendere",
      "date_updated": "Dato opdateret",
      "status": "Status",
      "action_dropdown": "Handlingsrulleliste",
      "calendar_list": "Tilknyttede tjenester",
      "edit": "Rediger",
      "duplicate": "Duplikere",
      "copy_embed_code": "Kopiér integreringskode",
      "copy_permanent_link": "Kopiér permanent link",
      "copy_new_slug_link": "Kopiér link til planlægning",
      "copy_scheduling_link": "Kopier link til planlægning (forældet)",
      "deactivate_calendar": "Deaktiver kalender",
      "move_to_group": "Flyt til gruppen",
      "delete_calendar": "Slet kalender",
      "delete_group": "Slet",
      "delete_this_group": "Slet denne gruppe",
      "activate_calendar": "Aktivér kalender",
      "duration": "Varighed",
      "multiple_durations": "Flere",
      "all": "hver",
      "draft": "Kladde",
      "inactive": "Inaktiv",
      "active": "Dynamisk",
      "actions": "aktiviteter",
      "rearrange_calendars": "Omarranger kalendere",
      "deactivate_all_calendars_in_group": "Suspendere hver kalendere in gruppen",
      "activate_all_calendars_in_group": "udløser hver kalendere in Gruppe",
      "no_groups_found": "Din Søge matchede ikke nogen kalender Gruppe.",
      "no_groups_in_location": "Gruppe Sortere dine kalendere Synes godt om Mappe. Tilføj kalendere til en gruppe, og slet et individuelt Link til planlægning, så Booker vælge fra flere kalendere.",
      "no_calendars_found": "Kom i gang Via kalender Via Oprettet ny kalender.",
      "no_calendars_found_search": "Din Søge matchede ikke nogen kalendere.",
      "delete_calendar_message": "Du er ved at slette kalenderen. Når du trykker på slet, vil det også slette alle dets aftaler.",
      "delete_calendar_message_title": "Slet denne kalender?",
      "duplicate_calendar_message": "Du er ved at duplikere kalenderen. Dette vil oprette en ny kalender med de samme indstillinger som den valgte kalender.",
      "duplicate_calendar_message_title": "Dupliker denne kalender?",
      "no_calendars_found_title": "Der blev ikke fundet nogen kalendere",
      "no_groups_in_location_title": "Der blev ikke fundet nogen grupper",
      "delete_group_confirmation_title": "Slet denne gruppe?",
      "delete_group_confirmation": "Er du sikker på, at du ønsker at slette Valgt Gruppe?",
      "delete_group_confirmation_checkbox_title": "Slet Medlemmer kalendere og Aftale",
      "delete_group_confirmation_checkbox_description": "Hvis du vælger denne mulighed, slettes også kalenderne in denne gruppe sammen med hver Aftale in disse kalendere.",
      "group_status_message_title": "{status} gruppe og alle tilknyttede kalendere?",
      "calendar_status_message_title": "{status} denne kalender?",
      "calendar_status_message": "Du er ved at {status} kalender.",
      "group_status_active_message": "Er du sikker på, at du vil aktivere denne gruppe? Alle kalendere i kalendergruppen vil også blive aktiveret og tilgængelige for booking.",
      "group_status_inactive_message": "Er du sikker på, at du vil deaktivere denne gruppe? Alle kalendere i gruppen vil også blive deaktiveret og være tilgængelige for booking.",
      "coming_soon": "Kommer snart",
      "select": "Vælge",
      "15mins": "15 min.",
      "cancel": "Annuller",
      "save": "Arkiv",
      "create": "Opret",
      "select_calendar_group": "Vælg kalendergruppe",
      "move_calendar_confirmation": "Det gamle link vil stoppe med at fungere, når du fortsætter med denne ændring. Bekræft ved at vælge afkrydsningsfeltet.",
      "previously_called_unassigned": " (Tidligere kaldt som ikke tildelt)",
      "scheduling_type": "Vælg kalendertype",
      "scheduling_type_description": "Vælg en Kalendertype for at konfigurere din kalender og Tilpas, hvor Aftale er Planlagt.",
      "service_menu_name": "Servicemenu navn",
      "template": "Skabelon",
      "select_template": "Vælg skabelon",
      "group_url": "Gruppe URL",
      "template_description": "Du har nu valget mellem at vælge enten Classic- eller Neo-skabelonen til gruppevisningen.",
      "rooms": "Rum",
      "rooms_name": "Navn",
      "rooms_description": "Beskrivelse",
      "rooms_modal_description": "Tilføj eller rediger rum.",
      "rooms_capacity": "Samlet kapacitet",
      "no_rooms_in_location_title": "Ingen rum fundet",
      "no_rooms_in_location": "Ingen rum fundet in denne placering",
      "no_equipments_in_location": "Intet Udstyr fundet in denne Placering",
      "equipments": "Udstyr",
      "equipment_name": "Navn",
      "equipment_name_search": "Udstyrsnavn",
      "equipment_description": "Beskrivelse",
      "equipment_modal_description": "Tilføj eller rediger en enhed.",
      "add_equipment": "Tilføj/rediger udstyr",
      "add_room": "Tilføj/rediger rum",
      "equipment_quantity": "Total mængde",
      "equipment_outOfService": "Ude af drift-antal",
      "no_equipments_in_location_title": "Intet Udstyr fundet",
      "delete_this_equipment": "Slet dette Udstyr",
      "delete_this_rooms": "Slet denne rom",
      "delete_equipment_confirmation": "Er du sikker på, at du vil slette dette Udstyr? Dette vil også være Slettet fra hver the Tredjepartskalendere.",
      "delete_rooms_confirmation": "Er du sikker på, at du vil slette denne rom? Dette vil også være Slettet fra hver the Tredjepartskalendere.",
      "add_new_calendar_equipments": "Tilføj nyt Udstyr",
      "no_equipments_found": "Din Søge matchede ikke noget Udstyr.",
      "no_rooms_found": "Din Søge matchede ikke nogen rom.",
      "add_new_calendar_rooms": "Tilføj ny Rum",
      "rooms_disable": "Deaktiver rum",
      "equipments_disable": "Deaktiver udstyr",
      "equipments_activate": "Aktivér udstyr",
      "rooms_activate": "Aktivér rum",
      "create_equipments": "Opret udstyr",
      "create_rooms": "Opret et rum",
      "select_calendar_rooms_title": "Vælge kalender",
      "select_calendar_rooms_description": "Du kan vælge flere kalendere, der skal tilknyttes rum.",
      "select_calendar_equipments_title": "Vælge kalender",
      "select_calendar_equipments_description": "Du kan vælge én kalender til at knytte til udstyret.",
      "disable_equipment_title": "{status} Udstyr",
      "disable_room_title": "{status} Rom",
      "equipments_status_message": "Er du sikker på, at du vil {status} dette udstyr?",
      "rooms_status_message": "Er du sikker på, at du vil {status} dette rum?",
      "calendar_resource_disclaimer": "Dette kan påvirke Tilgægelselighed Til Medlemmer servicekalendere.",
      "equipment_disclaimer": "Note: Hvis du aktiverer Udstyr senere, vil du automatisk Opret forbindelse igen den til kalendere, den er Medlemmer med",
      "room_disclaimer": "Note: Hvis du aktiverer Rummet senere, vil du automatisk Opret forbindelse igen den til de kalendere, den er Medlemmer med",
      "equipment_tab_name": "Udstyr",
      "rooms_tab_name": "Rum",
      "manage_your_rooms": "Administrator Rum til din Virksomhed her",
      "manage_your_equipments": "Administrer Udstyr for din Virksomhed her",
      "select_service_calendar_description_equipments": "Du kan vælge flere bookingkalendere, der skal knyttes til udstyr.",
      "select_service_calendar_description_rooms": "Du kan vælge flere bookingkalendere, der skal knyttes til værelser.",
      "service_menus": "Servicemenu",
      "manage_your_calendars_groups_and_service_menus": "Administrer dine kalendere, gruppe og servicemenu",
      "new_service_menu": "Opret servicemenu",
      "deactivate_service_menu": "Deaktiver servicemenu",
      "delete_service_menu": "Slet denne servicemenu",
      "delete_service_menu_confirmation": "Er du sikker på, at du vil slette denne servicemenu?",
      "service_menu_status_message_title": "{status} denne servicemenu?",
      "service_menu_status_message": "Du er ved at {status} servicemenuen.",
      "no_service_menus_in_location_title": "Opret din brugerdefinerede servicemenu",
      "add_new_service_menu": "Tilføj ny servicemenu",
      "no_service_menus_in_location": "Start Via Oprettet en ny servicemenu og tilføj Gruppe dertil",
      "no_service_menu_found": "Ingen service-menu fundet",
      "no_service_menu_found_desc": "Din Søge matchede ikke nogen servicemenuer.",
      "apply": "Anvend",
      "troubleshoot_calendar": "Fejlfinding af kalender",
      "round_robin_booking": "Automatisk tildeling af aftaler",
      "round_robin_description": "Fordeler Aftale blandt Gruppe Medlemmer in en roterende Sortere.",
      "round_robin_example": "F.eks.: Salg-opkald, Onboarding sessioner.",
      "unassigned_booking": "Begivenhedskalender",
      "unassigned_description": "Til Planlæg fysisk tilfælde uden Vært Relation.",
      "unassigned_example": "F.eks.: Konferencer, Offentlige seminarer, udstillinger.",
      "event_booking_alert_title": "Vigtigt",
      "event_booking_alert_message": "Denne kalendertype har vigtige forskelle",
      "event_booking_learn_more": "Få mere at vide",
      "event_booking_tooltip_title": "Ting du skal vide:",
      "event_booking_tooltip_content": "• Begivenhedskalendere har ikke brugere, så møder kan ikke tildeles en bruger.\n• Fordi der ikke er tildelt nogen bruger, understøttes værktøjer til dynamiske mødelinks ikke (Zoom, Google Meet, Microsoft Teams). For at bruge onlinemøder skal du kopiere et statisk konferencelink fra et hvilket som helst værktøj og indsætte det i mødeplaceringen.\n• Fordi der ikke er tildelt nogen bruger, synkroniseres møder ikke til en brugers kalender fra Kalenderindstillinger → Forbindelser. Konfliktkalendere, der tilføjes der, tages ikke i betragtning.\n• Møder synkroniseres kun til den kalender, der er valgt under Ekstern synkronisering for denne kalender.\n• Begivenheder hentes fra og overføres kun til den valgte eksterne kalender.\n• Kun én Google-kalender kan tilsluttes ved hjælp af ekstern synkronisering.",
      "class_booking": "Klassebooking",
      "class_booking_description": "Et Vært mødes med flere Medlemmer.",
      "class_booking_example": "F.eks.: Webinarer, Gruppe Kurser, online .",
      "collective_booking": "Gruppebooking",
      "collective_booking_description": "Flere værter mødes med en medlem.",
      "collective_booking_example": "F.eks.: Panelinterviews, udvalgsanmeldelser.",
      "service_booking": "Servicebooking",
      "service_booking_description": "Problemfri Planlæg til servicebaserede virksomheder.",
      "service_booking_example": "F.eks.: Spa Aftale, reparation Serviceydelser, konsultationer.",
      "personal_booking": "Personlig booking",
      "personal_booking_description": "Planlæg en-til-en-møder med en bestemt Gruppe Medlemmer.",
      "personal_booking_example": "F.eks.: Bygherremøder, Private konsultationer.",
      "personal": "Personligt",
      "explore_more_types": "Udforsk flere Kategorier",
      "no_calendars_added": "Ingen kalendere endnu – opret en!",
      "no_calendars_added_description": "Opret din første kalender for at starte Planlæg ubesværet.",
      "no_groups_added": "Ingen grupper endnu – begynd at organisere dig!",
      "no_calendars_yet": "Ingen kalendere endnu",
      "no_groups_yet": "Der er endnu ingen grupper",
      "no_calendars_access": "Der er ikke blevet oprettet nogen kalendere endnu. Når en kalender er Oprettet, vises den hende. Du har ikke Få adgang til at opret en kalender — kontakt din Admin Hvis nødvendig.",
      "no_groups_access": "Ingen Gruppe har været Konfigurer endnu. Når en Gruppe er Oprettet, vises den hende. Du har ikke Få adgang til at Opret a Gruppe—kontakt din Admin Hvis nødvendig.",
      "no_groups_added_description": "Brug Gruppe til at se dine kalendere strukturerede. Tilføj kalendere til en gruppe og Slet en Individuel Gruppe Link til planlægning for Enkel-booking.",
      "group_success_message": "Gruppe er oprettet. Du can nu Inkludere kalendere til denne gruppe.",
      "choose_calendars": "Vælg kalendere",
      "do_it_later": "Jeg gør det senere",
      "add_calendars_to_group": "Tilføj kalendere til gruppen",
      "select_calendars_to_add": "Vælg hver de kalendere, du vil inkludere i gruppen {name}",
      "add_calendars": "Tilføj kalender(e)",
      "continue": "Fortsætte",
      "conflicting_calendars": "Kalendere med konflikter",
      "conflicting_calendars_description": "Efterfølgende kalendere er allerede en del af Andet Gruppe. Vil du flyve dem til din nye gruppe <b>{name}</b>?",
      "group_associated_with": "Aktuel Gruppe",
      "move_calendar_consent": "Jeg Aktivere Flytte disse kalendere til ny Gruppe.",
      "calendars_moved_successfully": "hver Valgt-kalendere er blevet flyttet til {name}.",
      "new_group": "Ny gruppe",
      "back": "Tilbage",
      "share_otl": "Slet din Tilgældighed hver Dato med et unikt Link , der Udløber Efter en booking, hvilket sikrer administratoren Få adgang til.",
      "copied_to_clipboard": "Kopieret til udklipsholder",
      "generate_link": "Generér nyt link",
      "generate_link_error": "Kunne ikke generere engangslink. Prøv igen.",
      "share_schedule_link": " Link til planlægning bestemmes Via Slug. Ændre the Slug, og Link til planlægningen tilpasser sig automatisk modifikationen.",
      "share_permanent_link": "Ideelt til Tragter, Website Omdirigeringer, Eller Annoncer. Det permanente Link forbliver konstant, upåvirket Via Slug Dynamisk.",
      "copy": "Kopiér",
      "share_embed_code": "Placering denne kode in din HTML , hvor du ønsker, at din {embedType} Widget skal vises.",
      "scheduling_link": "Link til planlægning",
      "permanent_link": "Permanent link",
      "one_time_link": "Engangslink",
      "embed_code": "Indlejringskode",
      "qr_code": "QR-kode",
      "qr_code_load_error": "Kunne ikke indlæse QR-koden",
      "loading": "Indlæser...",
      "share_group": "Del gruppe",
      "edit_group": "Rediger gruppe",
      "more_options": "Flere muligheder",
      "share_calendar": "Del kalender",
      "edit_calendar": "Rediger kalender",
      "troubleshoot_calendar_link": "Fejlfinding af kalender",
      "calendar_config_success": "Du har konfigureret din personlige/Gruppe-kalender",
      "close": " Luk",
      "added_calendars": "Tilføjede kalender(e)",
      "select_calendars": "Vælg kalender(e)",
      "settings_confirmation": "Til Fortsæt, bekræft disse Dynamisk.",
      "consent_checkbox_title": "Jeg forstår og accepterer disse ændringer.",
      "confirm": "Bekræft",
      "create_group_access_disabled": "Du har ikke Godkendelse til Opret a Gruppe. Kontakt din Admin for at få adgang til.",
      "create_calendar_access_disabled": "Du har ikke Godkendelse at Opret en kalender. Kontakt din Admin for at få adgang til.",
      "create_room_access_disabled": "Du har ikke tilladelse til at administrere rum. Kontakt din admin for at få adgang.",
      "create_equipment_access_disabled": "Du har ikke tilladelse til at administrere udstyr. Kontakt din admin for at få adgang.",
      "preview_booking_widget": "Forhåndsvisning af booking-widget",
      "share_service_menu": "Del servicemenu",
      "back_message": "Tilbage til kalenderlisten",
      "service_calendars": "Bookingkalendere",
      "owned_by": "Ejet Via",
      "owned_by_anyone": "Enhver",
      "owned_by_me": "Mig",
      "all_groups": "Alle grupper",
      "all_calendars": "Alle kalendere",
      "not_grouped": "Ikke grupperet",
      "delete_group_desc": "Er du sikker på, at du vil slette denne gruppe? Dette vil også slette hver kalenderens medlemmer med denne gruppe.",
      "calendar_listing_title": "Kalenderoversigt",
      "calendar_group_name": "Kalender-/gruppenavn",
      "success": "Gennemført",
      "my_calendar": "min-kalender",
      "service_calendar_description": "Problemfri planlægning til servicevirksomheder"
    },
    "preferences": {
      "preferences": "Indstillinger",
      "my_preferences": "Mine indstillinger",
      "account_preferences": "Kontoindstillinger",
      "user_preferences": "Brugerpræferencer",
      "set_preferences": "Samling af dine Indstillinger til din Konto.",
      "scheduling_options": "Planlægningsmuligheder",
      "meeting_location": "Konferencer Placering",
      "zoom": "Zoom",
      "save_preferences": "Gem præferencer",
      "in_app_preferences": "App-indstillinger",
      "set_start_day": "Samling Indstillinger Synes godt om start Dag til appen",
      "view_options": "Vis valgmuligheder",
      "services": "Serviceydelser",
      "feature_toggle_aria": "Aktivér funktion",
      "week_starts_on": "Ugen begynder om",
      "sunday": "Søndag",
      "widget_preferences": "Indstillinger for Widget",
      "set_widget_language": "Samling Indstillinger Synes godt om Sprog for Widget",
      "language_and_region": "Sprog og Stat",
      "language": "Sprog",
      "english": "Engelsk",
      "time_format": "Tidsformat",
      "time_format_value": "PM",
      "monday": "Mandag",
      "custom_meeting_location": "Brugerdefineret mødested",
      "view_appointments_in_1": "Se aftaler i",
      "timezone_uses_details_1": "Vi vil bruge denne tidszone til at vise aftaletider i hele appen og i dine aftalerelaterede e-mails – kun for dig. Den påvirker ikke din tilgængelighed, eller hvordan andre booker hos dig.",
      "business_timezones_1": "Virksomhedens tidszone",
      "business_timezones_tooltip_1": "Besked: Ved at vælge denne mulighed sikrer du, at din Præference stemmer overens med den valgte Virksomhedstidszone. Hvis virksomhedens tidszone ændres, vil din visningstidszone automatisk blive justeret for at matche.",
      "recommended_timezones": "Anbefalede tidszoner",
      "all_timezones": "Alle tidszoner"
    },
    "availability": {
      "availability": "Tilgængelighed",
      "my_availability": "Min tilgængelighed",
      "my_availability_and_booking_rules": "Tilgængelighedsskema",
      "my_availability_and_booking_rules_description": "Angiv, hvornår møder kan bookes baseret på personalets tilgængelighed.",
      "account_availability": "Kontotilgængelighed",
      "timezone": "Tidszone",
      "working_hours": "Arbejdstider",
      "set_recurring_hours": "Samling af din Tilbagevendende arbejdstid for Konferencer",
      "select_one": "Vælg en",
      "sunday": "Søndag",
      "monday": "Mandag",
      "tuesday": "Tirsdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lørdag",
      "widget_preferences": "Indstillinger for Widget",
      "set_widget_language": "Samling Indstillinger Synes godt om Sprog for Widget",
      "language_and_region": "Sprog og Stat",
      "language": "Sprog",
      "english": "Engelsk",
      "copy_to_all": "Kopiér to hver",
      "save_availability": "Gem tilgængelighed",
      "add_time": "Tilføj tid",
      "to": "Til",
      "select_time": "Vælg tidspunkt",
      "add_user": "Tilføj bruger",
      "accessRestricted": {
        "header": "Adgang begrænset",
        "message": "Du er ikke en del af denne konto. For at få adgang skal du tilføje dig selv til denne konto via Agenturindstillinger > Teams > Rediger teammedlem og tildele kontoen under 'Roller og tilladelser'.",
        "contact_admin": "Denne side er kun offentlig for administratorer. Kontakt din Admin for at få hjælp.",
        "button_text": "Gå til agenturindstillinger."
      },
      "schedule": {
        "edit_schedule": "Rediger skema",
        "schedule_name": "Skemanavn",
        "schedule_name_required": "Skemanavn er påkrævet",
        "timezone": "Tidszone",
        "timezone_placeholder": "Vælg en",
        "start_time": "Starttid",
        "end_time": "Sluttid",
        "add_availability_hour": "Tilføj tilgængelige timer",
        "remove_availability_hour": "Fjern tilgængelighedstime",
        "unavailable": "Ikke tilgængelig",
        "schedule_created": "Skemaet er blevet oprettet",
        "schedule_updated": "Skemaet er blevet opdateret",
        "calendars_selected": "{count} kalender",
        "calendars_selected_multiple": "{count} kalendere",
        "select_users_placeholder": "Søg efter brugere",
        "edit_default_schedule": "Rediger dette skema",
        "customize_event_type_schedule": "Tilpas skema kun for denne kalender",
        "multi_user_description": "Opdater tilgængeligheden for <b>{count} valgte brugere</b> – {calendar}",
        "bulk_edit_warning_banner": "Masse-redigering aktiveret. Ændringer vil overskrive de eksisterende skemaer for alle valgte brugere.",
        "bulk_edit_slot_applies_to_all": "Det valgte tidsrum vil gælde for alle valgte brugere.",
        "bulk_edit_slot_applies_to_selected": "Det valgte tidsrum vil blive anvendt på {count} valgt(e) bruger(e).",
        "bulk_edit_applies_to_all": "Ændringerne vil gælde for alle {count} valgte brugere.",
        "bulk_edit_weekly_hours": "Masse-redigering af ugentlige arbejdstimer",
        "bulk_edit_weekly_hours_title": "Masse-redigering af ugentlige arbejdstimer",
        "bulk_edit_weekly_hours_desc": "Dette vil erstatte de ugentlige timer for alle brugere, der er anført nedenfor.",
        "edit_now": "Rediger nu",
        "bulk_edit": "Masserediger",
        "choose_days_weekly_hours": "Vælg dag(e) for at indstille ugentlige arbejdstimer",
        "assign_to": "Tildel til:",
        "configure_weekly_hours": "Konfigurer ugentlige arbejdstimer",
        "selected_users": "Valgte brugere:",
        "bulk_edit_select_users": "Vælg brugere, der skal anvendes",
        "bulk_edit_select_users_placeholder": "Vælg teammedlemmer ...",
        "bulk_edit_select_at_least_one": "Vælg mindst én bruger.",
        "bulk_edit_editing_for": "Redigering for:",
        "bulk_edit_applies_to": "Gælder for:",
        "bulk_edit_user_count": "{count} bruger",
        "bulk_edit_users_count": "{count} brugere",
        "show_less": "Vis mindre",
        "more": "mere",
        "confirm_delete": "Bekræft sletning",
        "confirm": "Bekræft",
        "delete_user_date_confirm": "Er du sikker på, at du vil slette de datospecifikke timer for <b>{userName}</b> den <b>{date}</b>?",
        "delete_date_confirm": "Er du sikker på, at du vil slette de datospecifikke timer for alle brugere på <b>{date}</b>?",
        "selected_calendar": "valgt kalender",
        "edit_schedule_alert": "Opdateringer foretaget her vil blive anvendt på",
        "schedule": "Planlæg",
        "no_availability": "Ingen tilgængelighed",
        "date_specific_hours_show_more": "flere",
        "date_specific_hours_show_less": "færre",
        "date_specific_hours_recurring_meetings_enabled": "Datospecifikke timer kan ikke tilføjes, fordi dette skema er knyttet til en kalender med aktiverede tilbagevendende møder. Deaktiver de tilbagevendende møder for at fortsætte.",
        "recurring_incompatible_with_date_hours": "Tilbagevendende møder kan ikke aktiveres, fordi brugerens skema har datospecifikke timer, hvilket er inkompatibelt.",
        "incompatible_schedule_with_recurring": "{user} skema indeholder dato-specifikke timer, som er uforenelige med tilbagevendende møder.",
        "incompatible_schedule_with_recurring_calendar": "Skemaet indeholder dato-specifikke timer, hvilket er uforeneligt med tilbagevendende møder.",
        "recurring_meetings_enabled_multi_user": "Tilbagevendende møder understøttes ikke for kalendere med flere teammedlemmer eller når et teammedlem har datospecifikke timer tilføjet til deres tidsplan.",
        "weekdays": "Hverdage, {timeRange}",
        "weekdays_hours_vary": "Hverdage, timer varierer",
        "weekend": "Weekend, {timeRange}",
        "weekend_hours_vary": "Weekend, timer varierer",
        "days_hours_vary": "{days}, timer varierer",
        "date_specific_hours_tab_name": "Datospecifikke timer",
        "date_specific_hours": "{count} datospecifikke timer",
        "date_specific_hours_1": "1 datospecifik time",
        "weekly_hours": "Ugentlige timer",
        "custom_schedule": "Tilpasset skema",
        "select_schedule": "Vælg en skema",
        "no_schedules_found": "Der blev ikke fundet nogen skemaer",
        "untitled": "Uden titel",
        "error_updating_schedules": "Fejl under opdatering af tidsplaner",
        "daily": "Daglig",
        "weekly": "Ugentlig",
        "monthly": "Månedligt",
        "custom": "Tilpasset",
        "this_is_required": "Dette er påkrævet",
        "search": "Søg",
        "edit_hours": "Rediger åbningstider",
        "schedule_name_duplicate": "Der findes allerede et skema med dette navn",
        "delete_schedule_title": "Vil du slette skemaet \"{scheduleName}\"?",
        "delete_schedule_description": "Denne handling kan ikke fortrydes. Er du sikker på, at du vil fortsætte?",
        "delete_schedule_negative_text": "Annuller",
        "delete_schedule_positive_text": "Ja, slet.",
        "active_on": "Aktiveret for",
        "weekly_working_hours": "Ugentlige arbejdstimer",
        "weekly_working_hours_subtext": "Vælg de dage og tidspunkter, du arbejder på",
        "copy_availability_hour": "Kopiér tilgængelighedstime",
        "mins": "Minutter",
        "hours": "Timer",
        "save_weekly_hours": "Gem ugentlige timer",
        "save_date_specific_hours": "Gem datospecifikke timer",
        "update_weekly_hours_for_users": "Opdater ugentlige timer for {count} brugere",
        "set_date_specific_hours_for_users": "Indstil datospecifikke timer for {count} brugere",
        "set_date_specific_hours_for_user": "Indstil datospecifikke timer"
      }
    },
    "connections": {
      "connections": "Forbindelser",
      "connect": "tilslut",
      "conferencing": "Konferencer",
      "my_connections": "Mine forbindelser",
      "account_connections": "Kontoforbindelser",
      "connection_preferences": "Forbindelsespræferencer",
      "manage_calendars_conferencing_channels": "Administrer kalendere og Konferencer",
      "main_integration_calendar": "Primære integrationskalender",
      "event_integration_calendar": "tilfælde Oprettet Til en System , som du er en del af, vil også være Oprettet Til denne integrerede kalender",
      "2way_sync": "2-vejs synkronisering: Opret System tilfælde fra tilfælde booket til den PRIMÆR integrerede kalender",
      "calendars": "Kalendere",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Kontrollér for konflikter",
      "choose_accounts_to_connect": "Vælg, hvilken Konto Du ønsker at oprette forbindelse",
      "payments": "Betalinger",
      "stripe": "Stripe",
      "ads": "Annoncer",
      "local_service_ads": "Lokale serviceannoncer",
      "fire_workflow": "Udløs arbejdsgangsudløsere for begivenheder booket via tovejssynkronisering",
      "connect_google_outlook": "Tilslut din Google/Outlook/iCloud -konto for at kunne vælge PRIMÆR-kalender.",
      "execute_automation": "Udfør automatisering",
      "save": "Arkiv",
      "lsa": "Lokale serviceannoncer",
      "no_write_access": "Du skriv ikke Få adgang til til denne kalender",
      "connection_remove_confirmation": "Du're Om to Uddrage denne Integration",
      "active": "Dynamisk",
      "icloud": {
        "title": "Integration af iCloud",
        "description": "To-faktorgodkendelse og en app-specifik password er påkrævet for at tilslutte din Konto.",
        "email": "iCloud -e-mailadresse",
        "password": "iCloud-adgangskode",
        "connect": "Tilslut",
        "cancel": "Annuller"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Vælg kontakt",
    "start_time": "Starttidspunkt",
    "unassigned": "Ikke tildelt",
    "end_time": "Sluttidspunkt",
    "search_by_name_email_phone_or_company": "Søge Via navn, e-mail, Telefon Eller Virksomhed",
    "add_new": "Tilføj ny",
    "pick_from_available_contacts": "Eller Vælge Fra ledige Venner",
    "book_appointment": "Book aftale",
    "add_blocked_off_time": "Tilføj blokeret tid",
    "recommended_timezones": "Anbefalede tidszoner",
    "all_timezones": "Alle tidszoner",
    "calendar": "Kalender",
    "repeat": "Gentagelse",
    "date_and_time": "Dato og klokkeslæt",
    "close": "Luk",
    "team_member": "Teammedlem",
    "recurring_booking": "Tilbagevendende booking",
    "one_slot_booking": "Booking af ét tidsrum",
    "event_type": "Begivenhedstype",
    "occurrences_booked": "tilfælde vil blive booket",
    "repeats": "Gentagelse",
    "booking_details": "Bookingoplysninger",
    "showing_slots_in_this_timezone": "Viser-pladser in denne tidszone:",
    "update_contact_tz": "Opdater også kontaktens tidszone til",
    "date": "Dato",
    "slot": "tidsrum",
    "calendar_default": "Kalenderstandard",
    "custom": "Tilpasset",
    "meeting_notes": "(f.eks.) Konferencer-noter til vores kommende Aftale",
    "out_of_office": "(eg) Fra kontor for Uge!",
    "standard": "Standard",
    "appointment_title": "Aftalens titel",
    "event_title": "Begivenhedstitel",
    "appt_with_bob": "(f.eks.) Aftale med Bob",
    "vacation": "(f.eks.) Ferie",
    "show_notes": "Vis noter",
    "hide_notes": "Skjul noter",
    "additional_preferences": "Yderligere præferencer",
    "meeting_location": "Mødested",
    "appointment_status": "Aftalestatus",
    "appt_description": "Aftalebeskrivelse",
    "recurring_details": "Tilbagevendende oplysninger",
    "event_description": "Begivenhedsbeskrivelse",
    "in_contact_timezone": "in Kontaktes tidszone",
    "vacation_message": "Skal du til ferie? Tager du noget Dato-deaktiveret? Bloker deaktiveret Dato Til din kalender for at forhindre Kunder Fra booking Aftale Aktuel Aftale vil stadig være til din kalender).",
    "contact": "Kontakte",
    "delete": "Slet",
    "cancel": "Annuller",
    "back": "Tilbage",
    "pick_available_contacts": "Eller Vælge Fra ledige Venner",
    "no_contacts_found": "Ingen Venner fundet",
    "found": "fundet",
    "select_one": "Vælg en",
    "tz_tooltip": "Dette er kun vigtigt Hvis Du're Via Brugerdefinerede værdier; såsom Aftale Aftale Aftale osv. in din Udgående Kommunikation med dine Kunder Eller Kunder. Og det, den simpelthen gør, er at konvertere de førnævnte Oplysninger til deres lokale Dato.",
    "meeting_location_tooltip": "Konferencer Placering vil være Samling som konfigureret in kalenderen.",
    "appt_meeting_location_tooltip": "Brugeren kan Samling den Konferencer-placering, der er specifik for Aftale.",
    "gmeet_tooltip": "Sørg venligst for, at det pågældende teammedlem har en Google-kalender indstillet som deres primære kalender.",
    "zoom_tooltip": "Sørg venligst for, at det pågældende teammedlem har Zoom-integration.",
    "enter_meeting_location": "Indtast mødested",
    "save_appointment": "Gem aftale",
    "save_event": "Gem begivenhed",
    "search_contacts": "Søge Via navn, e-mail, Telefon Eller Virksomhed",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Tilpasset tidszone",
    "system_timezone": "Systemtidszone",
    "contact_timezone": "Kontakttidszone",
    "account_timezone": "Kontotidszone",
    "an_error_occurred": "Der opstod en fejl"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Aftalens ejer",
    "source": "Kilde",
    "booked_by": "Booket af",
    "view_activity_log": "Se aktivitetslog",
    "status": "Status",
    "cancel_appointment": "Aflys aftale",
    "cancel_all": "Aflys alle",
    "google_event": "Google-begivenhed",
    "outlook_event": "Outlook-begivenhed",
    "blocked_slot": "Spærret tidsrum",
    "appointment": "Aftale",
    "confirmed": "Bekræftet",
    "unconfirmed": "Ubekræftet",
    "cancelled": "Aflyst",
    "showed": "Fremmødte",
    "no_show": "Udeblevet",
    "invalid": "Ugyldig",
    "more": "Mere",
    "less": "Mindre",
    "edit": "Rediger",
    "reschedule_all": "Ændr alle",
    "guests": "Gæst(er)",
    "guest_count": "Gæst(s) Optælling"
  },
  "create_calendar": {
    "calendar_name": "Kalenderens navn",
    "calendar_logo": "Logo",
    "select_team_member": "Vælge Gruppe Medlemmer",
    "select_single_team_member": "Vælg gruppemedlem",
    "eg_outbound_reach": "(f.eks.) Udgående rækkevidde",
    "description": "Beskrivelse",
    "amount": "Beløb",
    "description_placeholder": "Skriv Beskrivelse",
    "meeting_duration": "Konferencer Varighed",
    "meeting_location": "Mødested",
    "seats_per_class": "Pladser pr. Klasse",
    "group": "Gruppe",
    "custom_url": "Tilpasset URL",
    "meeting_invite_title": "Konferencer invitationstitel",
    "event_color": "Farve på Begivenhed",
    "availability_type": "Tilgældighed Skrive",
    "new_calendar": "Ny kalender",
    "add_description": "Tilføj beskrivelse",
    "remove_description": "Uddrage Beskrivelse",
    "booking_availability": "Tilgængelighed af booking",
    "slug_tooltip": "Tilpas URL'en til booking-widgeten.",
    "meeting_location_tooltip": "Mødelinks vises i kalenderbegivenheder som 'Mødested' og giver dig mulighed for at tilføje elementer som Zoom-links til begivenheden.",
    "advanced_settings": "Avancerede indstillinger",
    "show_more_schedule": "Vis mere",
    "show_more_helper_text": "Gå til de avancerede indstillinger for yderligere at tilpasse dine åbningstider.",
    "reschedule_preference": "Ændr præference for tidsplan",
    "reschedule_preference_subtext": "Hvis en {contactLabel} ændrer en aftale:",
    "reassign_through_round_robin": "Reassign Via Automatisk tildeling af aftaler",
    "keep_same_assinged_user": "Se den samme Aftale Ejer",
    "new_appointment_preference": "Ny præference for aftale",
    "new_appointment_preference_text": "Book altid med {contactLabel}s tildelte bruger",
    "new_appointment_preference_subtext": "Book nye aftaler med {contactLabel}s tildelte bruger i stedet for at bruge automatisk tildeling af aftaler.",
    "cancel": "Annuller",
    "confirm": "Bekræft",
    "service_calendar_name": "Navn på service",
    "service_logo": "Logo",
    "service_select_team_member": "Vælg medarbejder",
    "service_duration": "Service Varighed",
    "appointment_invite_title": "Titel på Aftale",
    "payment_placeholder": "Indtast en beskrivelse, der vil blive vist til brugeren, der informerer vedkommende om betalingen",
    "deposit_amount": "Depositumsbeløb",
    "collect_deposit_amount": "Acceptér ufuldstændig betaling",
    "percentage": "Procentdel",
    "total_amount": "Beløb i alt",
    "enter_meeting_location": "Indtast mødested",
    "accept_payments": "Acceptér betalinger",
    "aria": {
      "should_accept_payment": "Skal acceptere betaling"
    },
    "calendar_name_tooltip": "Kalendernavn, der skal vises på booking-widgeten.",
    "booking_availability_tooltip": "Indstil de dage og tidspunkter, hvor bookinger kan foretages. Dette er dine ugentlige standardåbningstider, der vises til brugerne, når de vælger et tidsrum.",
    "select_team_member_tooltip": "Vælg de teammedlemmer, der skal deltage i dette møde.",
    "seats_per_class_tooltip": "Indstil det maksimale antal deltagere, der må tilmelde sig dette hold. Når alle pladser er optaget, vil tidsrummet ikke længere være tilgængeligt for booking.",
    "meeting_color": "Konferencer Farve",
    "meeting_duration_tooltip": "Dette angiver længden af dit møde og bestemmer, hvor længe det vil vare."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Hurtigt tip",
      "timezone_change_tip": "Tidszoner kan ændres når som helst under tidszonepræferencer.",
      "save": "Gem ændringer",
      "close": "Luk",
      "meeting_details": "Grundlæggende oplysninger",
      "availability": "Tilgængelighed",
      "forms_and_payment": "Formularer og betaling",
      "notifications_and_additional_options": "Notifikationer og yderligere valgmuligheder",
      "connections": "Forbindelser",
      "customizations": "Tilpasninger",
      "create": "Opret",
      "edit": "Rediger",
      "equipments": "Lokaler og udstyr",
      "service_details": "Oplysninger om service",
      "booking_rules": "Reservationsregler",
      "advanced_settings": "Avancerede indstillinger",
      "form_and_confirmation": "Formular og bekræftelse",
      "payments": "Betalinger",
      "notifications_and_policies": "Notifikationer og politikker",
      "widget_appearance": "Widgettens udseende",
      "saving_changes": "Kun et minut — Gemme den seneste Dynamisk ...",
      "calendar_id": "Kalender-id",
      "saveCalendarSuccess": "Kalenderen er gemt",
      "external_sync": "Ekstern synkronisering",
      "external_sync_and_channel": "Ekstern synkronisering og kanaler",
      "booking_channels": "Bookingkanaler",
      "meeting_location": "Mødested",
      "staff_location": "Medarbejdere og placering"
    },
    "meeting_details": {
      "meeting_location": "Konferencer Placering",
      "meeting_location_label": "Mødested",
      "enter_meeting_location": "Indtast Konferencer Placering",
      "click_to_upload": "klik for at Upload",
      "square": "Firkant",
      "circle": "Cirkel",
      "remove_logo": "Uddrage Logo",
      "meeting_invite_title_tooltip": "Dette er titlen på kalenderbegivenheden, der vises i din liste over aftaler, kalendervisning og tredjepartskalendere.",
      "event_color_tooltip": "Vælg en farve til denne begivenhed. Farver synkroniseres til begivenheder i Google-kalendere.",
      "enter_a_name": "Indtast et navn.",
      "enter_an_event_title": "Indtast en begivenhedstitel.",
      "high_priority": "Høj prioritet",
      "medium_priority": "Middel prioritet",
      "low_priority": "Lav prioritet",
      "priority": "Prioritet",
      "custom": "Tilpasset",
      "zoom_not_added": "Brugeren har endnu ikke forbundet deres Zoom-konto.",
      "opt_avail": "Optimer til Tilgænglighed",
      "opt_equal": "Optimer for ligeså mange muligheder",
      "team_members": "Vælge Gruppe Medlemmer",
      "team_members_location": "Vælg personale og tildel mødeplacering",
      "team_member": "Vælg teammedlem",
      "team_member_location": "Vælg personale og tildel mødeplacering",
      "meeting_location_required": "Mødested er påkrævet.",
      "meeting_details": "Grundlæggende oplysninger",
      "meeting_details_description": "Grundlæggende oplysninger, der anvendes til at identificere denne kalender.",
      "or_drag_and_drop": "Eller Træk og slip",
      "service_details": "Oplysninger om service",
      "team_member_disabled_recurring_tooltip": "Tilbagevendende møder Aktivere kun én Gruppe Medlemmer. For at inkludere flere Gruppe Medlemmer, bedes du Deaktivere Tilbagevendende møder.",
      "team_member_disabled_class_booking_tooltip": "Kun ét teammedlem kan tilføjes til et holds bookingkalender.",
      "advanced_settings": "Avancerede indstillinger",
      "enable_contact_assigned_to_setting": "For at aktivere denne Indstilling skal Formularen være først in Widget -sorteringen. Ændre the Widget Sortere fra fanen Formularer og betaling.",
      "reschedule_preference_setting_tooltip": "Vælg hvem aftalen skal tildeles, når en {contactLabel} flytter fra booking-widgetten.",
      "appointment_preference_tooltip": "Vælg, om nye aftaler altid skal bookes med den bruger, der er tildelt {contactLabel}. Hvis en {contactLabel} har en tildelt Bruger, vil denne Bruger have Præference; ellers vil det være en Automatisk tildeling af aftaler. Tip: Deaktiver \"Tillad personalevalg\" for at forhindre bookere i at ændre medarbejderen i booking-widgetten.",
      "add_location": "Tilføj en placering",
      "multiple_locations_neo": "Tilbyd flere placeringsmuligheder, som bookeren kan vælge imellem. Flere placeringer understøttes kun af Neo-widgetten.",
      "make_owner": "Opret Ejer",
      "only_one_team_member": "Kun ét Gruppe-medlem er tilladt, når der er tilføjet flere adresser.",
      "ask_the_booker_error_message": "\"Ask the Booker\"-placeringen findes allerede.",
      "enter_location": "Indtast placeringsværdi",
      "enter_display_label": "Indtast visningsetiket",
      "add_display_label": "Tilføj visningsetiket",
      "multiple_location_support_message": "Tilbyd flere placeringsmuligheder, som bookeren kan vælge imellem. Flere placeringer understøttes kun af Neo-widgetten.",
      "only_one_team_member_personal_calendar": "Kun ét teammedlem har tilladelse til en personlig booking. ",
      "ms_teams_not_added": "Brugeren har endnu ikke forbundet deres Microsoft Teams-konto.",
      "enable_new_appt_preference": "Aktivér ny præference for aftale",
      "enable_new_appt_preference_desc": "Når du aktiverer &quot;<b>Book altid med {contactLabel}s tildelte Bruger</b>&quot;, vil <b>formularen</b> automatisk blive indstillet som det første trin i widgetrækkefølgen.",
      "location_exists_toast": "Konferencer Placering allerede tilføjet",
      "not_supported_with_multiple_team_members": "Understøttes ikke med flere teammedlemmer",
      "not_supported_personal_calendar": "Understøttes ikke i personlig kalender",
      "not_supported_class_booking": "Understøttes ikke i klassebookingkalenderen",
      "not_supported_collective_booking": "Understøttes ikke i kollektiv kalender",
      "not_supported_service_booking": "Understøttes ikke i servicekalenderen",
      "not_supported_round_robin": "Understøttes ikke i automatisk tildeling af aftaler-kalender",
      "not_supported_event": "Understøttes ikke i begivenhedskalenderen",
      "calendar_logo_tooltip": "Vælg et logo, der skal vises på booking-widgetten.",
      "calendar_name_tooltip": "Kalendernavn, der skal vises på booking-widgetten.",
      "description_tooltip": "Beskriv, hvad kalenderen omfatter, som skal vises på booking-widgetten.",
      "group_tooltip": "Du kan tildele denne kalender til en gruppe (hvis den er oprettet). Brugere, der tilgår gruppelinket, kan gennemse og booke fra alle kalendere i den pågældende gruppe.",
      "custom_url_tooltip": "Tilpas URL'en til booking-widgetten.",
      "meeting_color_tooltip": "Vælg en farve til denne begivenhed.",
      "add_display_label_tooltip": "Skjul den faktiske placering, og vis en brugerdefineret etiket, indtil mødet er booket (gælder, når flere placeringer er tilføjet).",
      "meeting_location_tooltip": "Vælg en placering, eller vælg Brugerdefineret for at tilføje en hvilken som helst adresse eller mødelink.",
      "team_members_location_tooltip": "Vælg den medarbejder, der skal tage dette møde, og angiv deres mødeplacering.",
      "meeting_distribution": "Mødefordeling",
      "meeting_distribution_tooltip": "Vælg, hvordan møder tildeles til medarbejdere.",
      "opt_avail_tooltip": "Tildel møder til den medarbejder, der er ledig på det valgte tidspunkt, uanset tidligere reservationer. Maksimerer udnyttelsen af åbne tidsrum og succesrater for booking.",
      "opt_equal_tooltip": "Fordel møderne jævnt blandt alle medarbejdere ved at holde styr på tidligere bookinger. Prioriterer retfærdighed frem for tilgængelighed.",
      "priority_tooltip": "Indstil præferenceniveauet for tildeling af møder, når flere medarbejdere er tilgængelige. Personale med høj prioritet vil blive taget i betragtning først til bookinger, efterfulgt af personale med mellem og lav prioritet.",
      "contact_routing_preference": "Præference for kontaktstyring",
      "contact_routing_preference_tooltip": "Definer, hvordan nye og tilbagevendende {contactsLabel} tildeles til personalet – enten ved automatisk tildeling (round robin) eller til deres oprindelige ejer.",
      "team_members_location_owner_tooltip": "Den primære bruger, der ejer mødet og angiver den endelige mødeplacering.",
      "owner": "Ejer",
      "upload_from_system": "Upload fra system",
      "choose_from_media_storage": "Vælg fra medielager",
      "only_one_team_member_allowed": "Kun ét teammedlem er tilladt.",
      "at_least_two_team_members_required": "Mindst 2 teammedlemmer kræves.",
      "at_least_one_team_member_required": "Mindst ét teammedlem er påkrævet.",
      "widget_shape": "Widget-form:",
      "widget_bookings_path": "/widget/bookings/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profilbillede",
      "meeting_location_placeholder": "Mødested",
      "team_member_meeting_location": "Personale og mødeplacering",
      "meeting_location_desc": "Tildel medarbejdere til denne kalender, og angiv, hvor møderne finder sted.",
      "event_calendar_meeting_location_desc": "Vælg, hvor mødet skal finde sted."
    },
    "meeting_location": {
      "ask_the_booker": "Ask the Booker (booker indtaster placeringen)",
      "ask_the_booker_desc": "Bookeren bliver bedt om at indtaste en placering efter eget valg, når de booker",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "lc_meet": "Mødelokale",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefon",
      "full_address": "Adresse",
      "custom": "Tilpasset",
      "meeting_location": "Mødested"
    },
    "availability": {
      "my_availability": "Min Tilgænglighed",
      "calendar_availability": "Kalendertilgængelighed",
      "calendar_availability_desc": "Angiv, hvornår møder kan bookes i denne kalender.",
      "set_availability": "Samling af din Tilgældighed til kalenderen hende.",
      "standard": "Standard",
      "custom": "Tilpasset",
      "to": "Til",
      "copy_to_all": "Kopiér to hver",
      "add_time": "Tilføj Dato",
      "recurring_meeting": "Tilbagevendende Konferencer",
      "recurring_info": "Kun én bruger pr. kalender til tilbagevendende reservationer.",
      "repeat": "Gentagelse",
      "times_to_repeat": "gange til Gentagelse",
      "slots_unavailable": "Hvis tidsrum ikke er tilgængelige?",
      "overlap_status": "Aftale Status for overlappende tidsrum ",
      "meeting_interval": "Mødeinterval",
      "meeting_duration": "Konferencer Varighed",
      "minimum_scheduling": "Min.. Planlæg MEDDELELSE",
      "date_range": "Dato Omfang",
      "count_available_days_only": "Tæl kun tilgængelige dage",
      "count_available_days_only_tooltip": "Tæller kun de dage, hvor denne kalender har tilgængelighed, startende efter det minimale planlægningsvarsel. Hvis du f.eks. har lukket i weekenderne, vil et 2-dages interval på en fredag blive udvidet til at vise mandag og tirsdag.",
      "maximum_bookings_per_day": "Maks. bookinger pr. Dag",
      "maximum_bookings_per_slot": "Maks. bookinger pr. . tidsrum",
      "maximum_bookings_per_slot_per_user": "Maks. bookinger pr. tidsrum (pr. Bruger)",
      "seats_per_class": "Pladser pr. Klasse",
      "pre_buffer_time": "Før BUFFER Dato",
      "post_buffer_time": "Slet BUFFER Dato",
      "pre_buffer_tooltip": "Buffertid før aftale er ekstra tid, der kan tilføjes før en aftale, hvilket giver ekstra tid til at blive klar.",
      "post_buffer_tooltip": "Buffertid efter aftale er ekstra tid, der kan tilføjes efter en aftale, hvilket giver ekstra tid til at afslutte.",
      "buffer_time": "BUFFER Dato",
      "daily": "Daglig",
      "weekly": "Ugentlig",
      "monthly": "Månedlig",
      "skip_booking": "Spring over booking af ikke-tilgængelige tidsrum",
      "continue_booking": "Fortsætte med at booke",
      "book_next_available": "Book Næste tilgængelige tidsrum",
      "confirmed": "Bekræftet",
      "unconfirmed": "Ubekræftet",
      "enter_valid_hours": "Indtast en gyldig Åbne-tid",
      "enter_valid_avail": "Indtast en gyldig Tilpasset tilgældighed",
      "availability_type_tooltip": "Vælge Standard Tilgængelighed for månedlige bookinger, der tilbydes Ugentlig. Vælge Tilpasset for bookinger kun tilgængelig til specifikke datoer.",
      "meeting_interval_tooltip": "Styrer, hvor ofte bookingtidsrum vises.\nFor et møde på 30 min.:\n • Vælg 1 time for at vise tidsrum øverst i hver time. \n• Vælg 30 minutter for at vise tidsrum hver 30. min.",
      "date_range_tooltip": "tilfælde kan være planlagt over de næste n dage.",
      "maximum_bookings_per_day_tooltip": "Maksimalt antal møder tilladt pr. dag i denne kalender.",
      "maximum_bookings_per_slot_tooltip": "Begræns, hvor mange møder en bruger kan have i samme tidsrum. Hvis grænsen nås, tildeles bookingen til den næste bruger i køen med automatisk tildeling af aftaler, eller tidsrummet bliver utilgængeligt.",
      "add_days": "Tilføj dage",
      "month_on_day": "Månedlig Til Dag",
      "month_on_last_day": "Månedlig Til sidste",
      "day": "Dag",
      "week": "Uge",
      "month": "Måned",
      "mins": "Minutter",
      "hours": "Timer",
      "days": "Dage",
      "weeks": "Uger",
      "months": "Måneder",
      "meeting_interval_error": "Mødeintervallet skal være mellem 5 min. og 12 t.",
      "meeting_duration_error": "Mødets varighed skal være mellem 1 min. og 12 t.",
      "buffer_time_error": "Buffertiden skal være mindre end 12 timer.",
      "appointment_interval": "Aftale Kunder",
      "appointment_duration": "Aftale Varighed",
      "maximum_appointments_per_day": "Maks. Aftale pr. Dag",
      "subTitle": "Vælg datoen for at indstille specifikke timer.",
      "heading_1": "Ugentlige tilgængelige timer",
      "scheduling_availability_heading": "Bookingtilgængelighed",
      "scheduling_availability_tooltip": "Brug et eksisterende tilgængelighedsskema, eller opret et brugerdefineret skema til denne kalender.",
      "tooltip_1": "Angiv dit ugentlige tilgængelighedsskema. Dette er dine normale timer, der vil blive anvendt konsekvent på ugentlig basis.",
      "heading_2": "Hvornår er du tilgængelige?",
      "unavailable_label": "Ikke tilgængelig",
      "tooltip_2": "Ændre dit skema til specifikke datoer. Tilsidesættelse af din Månedlig Ugentlig tid Via markering af Tilgængelighed Eller ikke tilgængelighed for Valgt datoer.",
      "date_specific_level": "Tilføj Dato-specifikt tidspunkt",
      "specific_hours_button": "Datospecifikke timer",
      "specific_hours_description": "Indstil brugerdefineret tilgængelighed for specifikke datoer, der adskiller sig fra dit ugentlige skema.",
      "overlap_error": "Datotidsrum kan ikke OVERLAPERE",
      "apply": "Anvend",
      "copy_times_to": "Kopiér gange til",
      "no_date_specific_heading": "Ingen specifik dato eller tid er tilføjet.",
      "no_date_specific_description": "Du kan tilføje/fjerne specifikke datoer og tidspunkter i din tilgængelighed.",
      "recurring_disabled_conditions_tooltip": "Tilbagevendende møder er deaktiveret. For at udløse dem skal du sikre dig, at kalenderen kun har én Gruppe Medlemmer og ikke er tilføjet et datospecifikt klokkeslæt Eller ufuldstændig betaling.",
      "date_specific_hours_disabled_conditions_tooltip": "For at inkludere et datospecifikt tidspunkt, bedes du sikre dig, at Tilbagevendende møder er deaktiveret.",
      "recurring_disable_event_calendar_conditions": "Tilbagevendende møder er deaktiveret. For at udløser dem sikre, at der ikke er tilføjet et datospecifikt tidspunkt Eller ufuldstændig betaling.",
      "service_duration": "Service Varighed",
      "service_interval": "Serviceydelser",
      "service_interval_tooltip": "Mødeintervallet angiver, hvor ofte bookingtidsrum vises i kalenderen. For eksempel betyder et tidsrum på 1 t., at der vises tidsrum hver time for en begivenhed på 30 min. Et interval på 30 min. betyder, at tidsrum vises hvert 30. min.",
      "service_duration_tooltip": "Denne Fast the Længde af din Aftale, bestemmende, hvor længe den vil sidste.",
      "minimum_scheduling_tooltip": "Dette angiver den minimumstid, der kræves for at booke en aftale via kalenderwidgetten. Hvis aftaler f.eks. er indstillet til 4 t., kan de ikke bookes inden for 4 t. før deres starttidspunkt. Bookinger skal foretages mindst 4 t. i forvejen.",
      "look_busy_title": "Ser booket ud",
      "look_busy_helper_text": "Skjule en Procentdel af dine tilgængelige Aftale-spillemaskiner, Til Booking-widgeten for at fremstå mere travl og in .",
      "look_busy_percentage_description": "Skjul antallet af tilgængelige pladser med x%",
      "maximum_bookings_per_slot_tooltip_personal": "Maksimalt antal møder tilladt i et enkelt tidsrum.",
      "enable_recurring_title": "Aktivér tilbagevendende møde",
      "enable_recurring_desc": "Hvis du aktiverer <b>Tilbagevendende møder</b>, deaktiveres følgende indstillinger automatisk, da de ikke kan sameksistere:",
      "date_specific_hours": "Alle <b>datospecifikke timer</b> vil blive fjernet.",
      "multiple_team_members": "<b>Flere teammedlemmer</b> vil blive fjernet – kun ét teammedlem kan forblive i denne kalender.",
      "partial_payments": "<b>Ufuldstændig Betalinger</b> deaktiveres, og det fulde beløb vil blive opkrævet.",
      "select_team_member_to_keep": "Vælg en Gruppe Medlemmer at se in denne kalender:",
      "select_team_member": "Vælg teammedlem",
      "partial_payments_disabled": "Da delvise betalinger vil blive deaktiveret, hvordan ønsker du så at opkræve det fulde beløb for tilbagevendende aftaler?",
      "enable_date_specific_hours": "Aktivér datospecifikke timer",
      "enable_date_specific_hours_desc": "Hvis du aktiverer <b>datospecifikke timer</b>, deaktiveres følgende indstilling automatisk, da de ikke kan sameksistere:",
      "recurring_meetings_disabled": "<b>Tilbagevendende møder vil blive deaktiveret</b>. {contactsLabel} vil kun kunne booke individuelle aftaler baseret på de tilgængelige datoer, du har angivet.",
      "payment_preference": "Betalingspræference:",
      "team_members_in_this_calendar": "Teammedlemmer i denne kalender",
      "other_team_members": "Andre teammedlemmer (ikke tilføjet til denne kalender)",
      "select_team_member_tooltip": "Vælg de teammedlemmer, der skal deltage i dette møde.",
      "meeting_duration_tooltip": "Dette angiver længden af dit møde og bestemmer, hvor længe det vil vare.",
      "add_another_duration": "Tilføj endnu en varighed",
      "set_as_default": "Indstil som standard",
      "default_duration": "Standard",
      "max_duration_options_reached": "Maks. 3 varighedsmuligheder tilladt",
      "duplicate_duration_error": "Varighedsværdier skal være unikke",
      "empty_duration_error": "Mødevarighed er påkrævet.",
      "multi_duration_tooltip": "Tilbyd flere varighedsmuligheder (f.eks. 15, 30 eller 60 min). Kunderne kan vælge deres foretrukne varighed under bookingen.",
      "date_specific_hours_tooltip": "Juster din tidsplan for specifikke datoer. Tilsidesæt dine normale ugentlige åbningstider ved at markere tilgængelighed eller utilgængelighed for valgte datoer.",
      "recurring_meeting_tooltip": "Tillad møder at gentage sig flere gange i en tidsperiode.",
      "repeat_frequency_tooltip": "Vælg frekvensen af denne tilbagevendende begivenhed.",
      "time_to_repeat_tooltip": "Angiv det samlede antal hændelser.",
      "slots_unavailable_tooltip": "Vælg, hvad der skal ske, hvis et eller flere tidsrum i en tilbagevendende booking allerede er optaget.",
      "skip_booking_tooltip": "Kun de tilgængelige tidsrum vil blive booket. Eventuelle utilgængelige datoer i den tilbagevendende serie vil blive sprunget over.",
      "force_book": "Gennemtving booking",
      "force_booking_tooltip": "Alle tidsrum vil blive booket, selvom der opstår en konflikt. Brug med forsigtighed for at undgå dobbeltbooking.",
      "book_next_available_tooltip": "Hvis et valgt tidsrum ikke er tilgængeligt, bookes det næste ledige tidsrum på samme tilbagevendende tidsplan (f.eks. næste mandag, hvis det er ugentligt).",
      "slot_interval_tooltip": "Angiv afstanden mellem starttidspunkterne for på hinanden følgende ledige tidsrum. Hvis dit møde for eksempel varer 30 min., og du angiver intervallet til 60 min., kan en bruger booke kl. 9:00, derefter kl. 10:00 og så videre – selvom hvert møde kun varer 30 min.",
      "minimum_scheduling_notice_tooltip": "Kræv, at brugerne booker møder mindst så meget tid i forvejen.",
      "date_range_preferences_tooltip": "Angiv, hvor langt ud i fremtiden bookinger kan foretages fra dags dato.",
      "maximum_bookings_per_slot_preferences_tooltip": "Begræns, hvor mange møder der kan planlægges til det samme tidsrum.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Begræns, hvor mange møder der kan planlægges for det samme tidsrum (pr. bruger).",
      "pre_buffer_time_tooltip": "Tid til at blokere før hvert møde, så der er ekstra tid til at forberede sig.",
      "post_buffer_time_tooltip": "Tid til at reservere efter hvert møde, så der er ekstra tid til at afslutte.",
      "seats_per_class_tooltip": "Indstil det maksimale antal deltagere, der må booke denne klasse. Når alle pladser er fyldt, vil tidsrummet ikke længere være tilgængeligt for booking.",
      "maximum_bookings_per_slot_per_user_tooltip": "Begræns, hvor mange møder der kan planlægges til det samme tidsrum (pr. bruger).",
      "repeat_frequency": "Gentagelsesfrekvens",
      "slot_interval": "Tidsrumsinterval",
      "skip_booking_helper_text": "Kun de tilgængelige tidsrum vil blive booket. Eventuelle utilgængelige datoer i den tilbagevendende serie vil blive sprunget over.",
      "force_book_helper_text": "Alle tidsrum vil blive booket, selvom der er en konflikt. Brug med forsigtighed for at undgå dobbeltbooking.",
      "book_next_available_helper_text": "Hvis et Valgt tidsrum er ikke tilgængeligt, Book det Næste tilgængelige tidsrum Til det samme Tilbagegevendende skema (f.eks. Næste Mandag Hvis Ugentlig).",
      "bulk_edit": "Masserediger",
      "select_users": "Vælg brugere",
      "select_all": "Vælg alle",
      "times_to_repeat_tooltip": "Angiv det samlede antal hændelser.",
      "custom_recurrence": "Tilpasset gentagelse",
      "repeats_every": "Gentages hver",
      "availability_schedule": "Tilgængelighedsskema",
      "availability_schedule_desc": "Angiv, hvornår møder kan bookes baseret på personalets tilgængelighed.",
      "no_users_added": "Ingen medarbejdere tilføjet!",
      "no_users_added_description": "Tilføj medarbejdere for at kontrollere deres tilgængelighed",
      "add_users": "Tilføj medarbejdere",
      "minimum_scheduling_notice_error": "Indtast ≤ 1.440 min.",
      "please_select_date": "Vælg en dato for at fortsætte"
    },
    "forms_payment": {
      "forms": "Formularer og gæster",
      "forms_sub": "Konfigurer præferencer for den sidste side, der vises efter en vellykket booking.",
      "select_form": "Vælg formular",
      "enable_same_user_assignment": "Tildel kontakter til deres respektive kalenderteammedlemmer, hver gang der bookes en aftale.",
      "sticky_contacts_label": "Fastgjort {contactsLabel}",
      "sticky_contacts": "Forudfyld felter",
      "confirmation_page": "Bekræftelsesside",
      "default": "Standard",
      "thank_you_message": "Takkebesked",
      "redirect_url": "Omdirigerings-URL",
      "use_custom_form_rules": "Brug formularens indstillinger",
      "custom_form_confirmation_alert": "Denne kalender anvender en tilpasset formular. Eventuelle betingede regler, der er konfigureret til at vise eller skjule felter eller diskvalificere kundeemner, vil altid køre før booking.",
      "default_message_tooltip": "Viser den konfigurerede bekræftelsesbesked, efter aftalen er booket.",
      "redirect_url_tooltip": "Omdirigerer kunden til den konfigurerede side, efter at aftalen er blevet booket.",
      "use_custom_form_rules_tooltip": "Anvender den omdirigering eller tilpassede besked, der er defineret i den tilpassede formular. Hvis der ikke gælder nogen regel, vises kalenderens bekræftelsesbesked.",
      "thank_you": "Tak Du Besked",
      "enter_url": "Indtast URL",
      "enter_thank_you_message": "Indtast en takkebesked.",
      "amount_tab_hidden_label": "Pladsholder til fanen Beløb",
      "percentage_tab_hidden_label": "Procent fanepladsholder",
      "pixel_id": "Meta Pixel-id (Valgfri)",
      "auto_confirm": "Bekræft automatisk ny kalendermøder",
      "configure_payment": "Konfigurer betalinger Valgmuligheder",
      "accept_payments": "Acceptér betalinger",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Tilføj gæster",
      "add_guest_tooltip": "'Tilføj gæst' vil give din deltager mulighed for at tilføje flere deltagere til den samme aftale.",
      "add_guest_custom_form_tooltip": "Hvis du aktiverer denne mulighed, sendes en systemgenereret e-mail til gæster med et link til den tilpassede formular, når deres aftale er bekræftet. For at forhindre dobbelte emails skal du sikre dig, at der ikke allerede er konfigureret en separat bekræftelsesmail for gæster. (Bekræft dette i fanen Notifikationer > Bekræftelsesnotifikation).",
      "add_guest_same_form_check": "Send den samme formular for at indsamle oplysninger via e-mail til alle gæster.",
      "payment_tooltip": "Betaling vil kun komme i betragtning for PRIMÆR Gæst og ikke for gæster.",
      "default_form": "Standard (Fornavn, sidste navn, E-mail, Telefon, Noter)",
      "select_form_tooltip": "Hvis du ønsker at indsamle mere information end standardoplysningerne fornavn, efternavn, e-mail og telefon fra dem, der booker på denne kalender, skal du oprette en brugerdefineret formular i sider > formularer > builder og derefter vælge formularen via rullemenuen nedenfor.",
      "confirmation_page_tooltip": "Når nogen har foretaget en booking, kan du vælge at vise vedkommende en Tilpasset Besked til den samme side (Standard) eller omdirigere dem til en side efter dit valg (Omdirigering).",
      "add_guest_collect_email": "Navn og e-mail",
      "add_guest_collect_detail": "Indsaml gæsteoplysninger",
      "add_guest_count_only": "Kun Optælling",
      "guest_collection_mode_label": "Gæsteoplysninger, der skal indsamles",
      "guest_collection_mode_email": "Navn og e-mail",
      "guest_collection_mode_phone": "Navn og telefon",
      "guest_collection_mode_email_phone": "Navn, e-mail og telefon",
      "custom_email_notification": "Send tilpasset formular til gæster.",
      "consent_label": "Samtykke Afkrydsningsfelt",
      "consent_input_placeholder": "Tilføj samtykketekst",
      "same_user_assignment_tooltip": "For at aktivere denne Indstilling skal Formularen være først Til Widget. Ændre Widget til at Status the Formular første til at udløse denne Indstilling.",
      "consent_tooltip": "Bed kontakterne om at give samtykke, når der bookes et møde.",
      "stripe_error": "Op til to decimaler (Model: 25,99)",
      "auto_confirm_service": "Bekræft automatisk ny Aftale",
      "service_form_message": "Hvis en kontakt booker flere tjenester, vil de kun se standardformularen i servicemenuen.",
      "deposit_amount_error": "Indbetalingsbeløbet skal være mindre end Sum .",
      "deposit_percentage_error": "Indbetalings Procentdel skal være mindre end 100 %.",
      "partial_payment_tooltip": "Aktivere Ufuldstændig betalinger for at opkræve indbetalingsbeløb Fra Kunder under Aftale-bookingsprocesserne.",
      "partial_payment_enable_error": "Det indtastede Sum skal være større end 0 for Aktivere ufuldstændig betalinger.",
      "payment_disable_text_integration": "Integrer en betaling Udbyder under Betalinger > Integrationer for at begynde at acceptere betalinger",
      "payment_disable_text_recurring": "Betalingsmuligheden accepterer er ikke tilgængelig for Tilbagevendende møder. Deaktiver Tilbagevendende til Aktivere betalinger.",
      "date_and_time_selector": "Dato- og tidsvælger",
      "form_selector": "Formular",
      "order_step": "Trin",
      "widget_order_label": "Sortere Widget",
      "widget_order_tool_tip": "Omarranger rækkefølgen af 'Dato- og tidsvælger' og 'Formular' på kalenderwidgetten. Træk blot og omarranger efter dine præferencer.",
      "widget_re_order_tooltip": "Omarrangering er kun tilgængelig med Neo Widget -stilen. Skift til Neo til Aktivere omarrangering.",
      "widget_re_order_disabled_tooltip": "For at ændre rækkefølgen af widgets skal du deaktivere 'ny aftalepræference (book altid med {contactLabel}s tildelte bruger)' fra mødeoplysninger > gruppemedlemmer > avancerede indstillinger.",
      "payment_description_error": "Den maksimale tegngrænse på 1000 er nået.",
      "widget_multiple_location_disabled_tooltip": "Den klassiske widget understøtter ikke flere mødesteder. Fjern eventuelle ekstra placeringer for at bruge den klassiske widget.",
      "recurring_payment_label": "Tilbagevendende Aftale betaling",
      "enable_payments_for_guests": "Aktivér betalinger for gæster",
      "guest_payment_description": "Da Du've Aktiveret muligheden \"Tilføj Gæster\", kan Du også Vælge til pris pr. Gæst Når af booking.",
      "charge_per_attendee": "Pris pr. deltager",
      "charge_per_attendee_description": "Multiplicer Sum Via nummer af deltagere (inklusive gæster), når der opkræves betaling under booking.",
      "click_confirm_description": "Klik på Gem for at anvende disse ændringer.",
      "multiply_amount_guests": "Opkræve betaling for hver deltager",
      "multiply_amount_guests_description": "Når det er aktiveret, vil det beløb, der skal opkræves under bookingen, blive multipliceret med det samlede antal deltagere, inklusive gæster.",
      "first_appointment_only": "pris kun for den første Aftale",
      "all_appointments": "pris for hver Aftale upfront",
      "no_payment_provider_connected": "Ingen betalingsudbyder tilknyttet.",
      "no_default_payment_provider": "Ingen betaling Udbyder tilsluttet",
      "provider_not_supported": "Standard Udbyder understøttes ikke",
      "manage_payment_provider": "Administrer betalingsudbydere",
      "supported_providers": "Understøttede udbydere:",
      "paypal_razorpay_helper_text": "Betalinger vil kun blive behandlet via Razorpay, da PayPal ikke understøttes med tilpassede udbydere.",
      "rearrange_widget_order": "Omarranger rækkefølgen af widgets",
      "change_form_order": "Dynamisk formularen til anden Trin in Widget Sortere vil deaktivere Efterfølgende Indstilling:",
      "change_form_order_desc": "<b>Ny præference for aftale (book altid med {contactLabel}s tildelte bruger)</b> vil blive deaktiveret. Dette betyder, at aftaler kan bookes med ethvert tilgængeligt gruppemedlem i stedet for at være begrænset til den {contactLabel}s tildelte bruger.",
      "enable_mandatory_guest": "Opret tilføjer mindst ét Gæst Påkrævet. Gæst Felter vil være forudåbnet og skal udfyldes før booking.",
      "enable_mandatory_guest_count": "Foretag obligatorisk optælling af gæster på reservationswidgeten.",
      "require_guest_for_booking": "Kræv gæster til booking",
      "sticky_contacts_tooltip": "Forudfyld felter for kendt {contactsLabel}.",
      "auto_confirm_tooltip": "Markér automatisk nye møder som bekræftede uden at kræve manuel godkendelse. Deaktiver dette, hvis du ønsker at gennemgå og bekræfte hver booking manuelt, inden den planlægges.",
      "confirm_tooltip": "Når nogen foretager en booking, kan du vælge at vise dem en brugerdefineret besked på samme side (Standard) eller omdirigere dem til en side efter eget valg (Omdirigerings-URL).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Gør det muligt at opkræve betaling under bookinger.",
      "total_amount_tooltip": "Indstil det samlede gebyr for mødet.",
      "deposit_amount_tooltip": "Beløb, der skal opkræves ved reservation som et depositum.",
      "multiply_amount_guests_all_guests": "Opkræve betaling for hver deltagere, herunder gæster",
      "multiply_amount_guests_all_guests_tooltip": "Når det er aktiveret, vil det beløb, der skal opkræves under bookingen, blive multipliceret med det samlede antal deltagere, inklusive gæster.",
      "payment_description": "Betalingsbeskrivelse",
      "payment_description_desc": "Vises for bookeren, mens betalingsoplysninger indtastes.",
      "payment_description_tooltip": "Inkluder eventuelt nyttige detaljer om betalingen.",
      "test_mode_warning": "TestDynamisk – ingen reel Salg vil blive behandlet.",
      "pixel_id_tooltip": "Send booking-widget-aktivitet såsom visninger, klik og indsendelser til Meta ved hjælp af dit Pixel ID.",
      "forms_description": "Indstil dine præferencer og indstillinger for indsamling af kundeoplysninger under bookinger.",
      "payment_mode": "Betalingsmetode",
      "payment_mode_tooltip": "Skift mellem Testtilstand og Live tilstand for betalinger. in Testtilstand laves ingen reel fakturering — brug den til at simulere booking- og betalingsprocesser. Skift til Live tilstand for at acceptere faktiske betalinger Fra Kunder.",
      "enable_coupon": "Aktivér kuponkoder",
      "enable_coupon_tooltip": "Tillad kunder at anvende kuponkoder under booking. For at sikre, at de fungerer, skal du først oprette gyldige kuponkoder under Betalinger > Kuponkoder.",
      "payment_collection": "Betalingsopkrævning",
      "payment_collection_tooltip": "Vælg, om kunden skal debiteres ved booking, eller om du blot vil gemme deres kortoplysninger uden at foretage en opkrævning.",
      "charge_upfront": "Opkræv på forhånd",
      "save_card_on_file": "Gem kort i systemet",
      "save_card_on_file_desc": "Gem kundens kort sikkert under bookingen. Der opkræves intet ved booking.",
      "guests": "Gæster"
    },
    "notifications": {
      "third_party_cal": "Tredjepartskalenderindstillinger",
      "third_party_cal_desc": "Indstil dine præferencer for tredjepartskalendere.",
      "additional_settings": "Yderligere indstillinger",
      "additional_settings_desc": "Konfigurer yderligere indstillinger for din kalender.",
      "notifications": "Notifikationer",
      "notifications_sub": "Konfigurer, hvordan du sender bookingnotifikationer via e-mail, SMS, WhatsApp, taleopkald og app-beskeder.",
      "edit": "Rediger",
      "created_on": "Oprettet den",
      "updated_on": "Opdateret den",
      "delivered": "Leveret",
      "not_available": "Ikke relevant",
      "select_notification_type": "Vælg typen af notifikation.",
      "notification_person": "Hvem skal levere denne notifikation?",
      "contact": "{contactLabel}",
      "guest": "Gæst",
      "assigned_user": "Tildelt Bruger",
      "emails": "Gmail",
      "alert_email_address": "E-mailadresse til Advarsel",
      "ack_email": "Anerkendelse E-mail",
      "send_google_invites": "Aktivere Google Kalender for at Upload invitation eller opdater Gmail til deltagere.",
      "assign_user_to_contact_desc": "Når denne funktion er aktiveret, vil {contactLabel}s tildelte bruger matche ejeren af aftalen med den seneste ændring – uanset om den er blevet booket, ændret eller gentildelt.",
      "send_google_outlook_invites": "Tillad Google/Outlook/iCloud-kalenderen at sende invitationer og opdateringsmails til deltagerne.",
      "assign_user_to_contact": "Tildel {contactsLabel} til deres respektive kalenderteammedlemmer, hver gang der bookes en aftale.",
      "skip_assigning_user_to_contact": "Spring tildeling af {contactLabel} over, hvis {contactLabel} allerede har en tildelt bruger.",
      "skip_assigning_user_to_contact_desc": "Når denne funktion er aktiveret, vil en {contactLabel}s tildelte bruger forblive den samme, selvom aftalens ejer er en anden.",
      "assigned_staff": "Tildelt personale",
      "additional_emails": "Yderligere Gmail",
      "assign_user_to_staff": "Tildel altid kontakten til aftalens ejer.",
      "allow_cancellation": " Tillad annullering af møde",
      "allow_reschedule": "Tillad omlægning af mødet",
      "allow_cancellation_tooltip": "Når Aktiveret, vil blive tilføjet et Link til de ekstra noter Afsnit og inkluderet in kalenderinvitationen. Dette Link vil Udløbet som konfigureret før Konferenceren starter Dato, hvilket forhindrer Booker Fra i at annullere Konferenceren.",
      "allow_reschedule_tooltip": " Når Aktiveret, vil et Link til omplanlægning blive tilføjet til de ekstra noter Afsnit og inkluderet in kalenderinvitationen. Dette Link vil Udløbet som konfigureret før Konferenceren starter Dato, hvilket forhindrer Booker Fra i at omplanlægge Konferenceren.",
      "cancellation_link_expiry": "Link vil Udløbet",
      "reschedule_link_expiry": "Omlægning af Link vil Udløbet",
      "before_meeting": "Før Konferenceren",
      "cancellation_and_reschedule_policy": "Annullerings- og ombookingspolitik:",
      "meeting_invite_notes": "Mødeindkaldelsesnoter",
      "meeting_invite_notes_tooltip": "Tilføj noter, der vil fremgå i kalenderinvitationen, som sendes til kunderne. Disse noter vil blive synkroniseret med tredjepartskalendere i mødebeskrivelsen."
    },
    "connections": {
      "connections_heading": "Ekstern kalendersynkronisering",
      "booking_channels_heading": "Bookingkanaler",
      "booking_channels_description": "Konfigurer, hvordan denne kalender modtager bookinger fra eksterne platforme.",
      "connections_sub": "Synkroniser møder med eksterne kalendere, og administrer, hvordan begivenheder håndteres.",
      "link_to_calendar": "Link til kalender",
      "sync_option": "Mulighed for Synkronisering",
      "execute_automation": "Udfør automatisering",
      "fire_workflow": "Udløs arbejdsgang-udløsere for begivenheder booket via tovejssynkronisering.",
      "reserve_with_google": "Reserver med Google [Udfaset]",
      "reserve_with_google_setup": "Se opsætningsvejledning",
      "reserve_with_google_configure": "Konfigurer",
      "change": "Skift",
      "rwg_deprecation_notice": "Google har udfaset <b>Reserver med Google (Local Services Ads)</b>. Nye forbindelser eller ændringer til eksisterende forbindelser understøttes ikke længere. For at fortsætte med at modtage bookinger fra Google skal du bruge <b>Google Organic Booking</b> i stedet.",
      "rwg_category": "Kategori",
      "rwg_service_type": "Service",
      "connect_lsa": "Forbind med din lokale reklamekonto.",
      "reserve_error": "nu Book med Google understøttes kun for \"Home Serviceydelser\", \"Real Estate\", \"Legal Serviceydelser\" (lokale serviceudbydere) Virksomhedsniche in USA.",
      "one_way": "Envejs",
      "two_way": "Tovejs",
      "smart": "Smart",
      "confirm_remove": "Er du sikker på, at du vil Uddrage Google Kalender?",
      "read_only_access": "Du har ikke skrive Få adgang til til denne kalender. Vælg en anden kalender.",
      "reserve_with_google_desc": "Denne kalenderservice vil blive opført in Book kun med Google indtil en vellykket Integration.",
      "check_integration": "Status din Integration",
      "setup_external": "Opsæt ekstern kalender",
      "reserve_price_decimal_error": "Decimalpris understøttes ikke.",
      "reserve_price_max_error": "Prisen understøttes ikke under 1000.",
      "link_to_calendar_tooltip": "Vælg den eksterne kalender til at synkronisere møder med. Google-kalendere, der er tilsluttet i Kalenderindstillinger → Forbindelser, kan vælges.",
      "one_way_sync": "Envejs",
      "default_one_way": "Standardsynkronisering (envejssynkronisering)",
      "one_way_sync_desc": "Begivenheder fra den tilknyttede kalender synkroniseres som blokerede tidsrum, og der oprettes ingen kontakter for gæsterne.",
      "two_way_sync": "Tovejssynkronisering",
      "two_way_sync_desc": "Kontakter oprettes for gæster, der forefindes i begivenheder i forbundne kalendere, og disse begivenheder omdannes til systemaftaler.",
      "smart_sync": "Smart-synkronisering",
      "smart_sync_desc": "Begivenheder fra den tilknyttede kalender synkroniseres som aftaler for eksisterende kontakter. Hvis der ikke findes nogen kontakter, synkroniseres de som blokerede tidsrum uden at oprette en ny kontakt.",
      "sync_option_tooltip": "Vælg, hvordan begivenheder fra den eksterne kalender håndteres:\n• Envejs: Blokerer tid på denne kalender uden at oprette {contactsLabel}\n• Tovejs: Opretter møder og {contactsLabel} fra begivenheder i den eksterne kalender\n• Smart: Opretter kun møder for eksisterende {contactsLabel}, og blokerer tid for andre.",
      "default_sync": "Standard",
      "default_sync_desc": "Synkroniserer begivenheder fra din eksterne kalender til denne kalender.",
      "advanced_sync": "Avanceret",
      "advanced_sync_desc": "Synkroniserer begivenheder fra din eksterne kalender til denne kalender og opretter kontakter og aftaler i systemet.",
      "assign_contact_to": "Tildel kontakt til",
      "select_calendar": "Vælg kalender",
      "sync_preferences": "Synkroniseringsindstillinger",
      "sync_preferences_desc": "Hvordan vil du gerne synkronisere dine sammenkædede kalenderbegivenheder?",
      "recommended": "Anbefalet",
      "execute_automation_desc": "Udfør automatisering, når et møde oprettes i denne kalender",
      "save": "Gem ændringer",
      "cancel": "Annuller",
      "reserve_with_google_title": "Reservér med Google",
      "current_connection": "Nuværende aktiv forbindelse:",
      "category": "Kategori",
      "service": "Tjenestetype",
      "price": "Anslået pris",
      "currency": "Valuta",
      "client_portal_booking": "Kundeportalbooking",
      "client_portal_booking_description": "Tillad, at denne kalender vises på Kundeportalens bookingliste",
      "client_portal_url": "URL til kundeportal"
    },
    "booking_rules": {
      "booking_rules": "Reservationsregler",
      "booking_rules_description": "Kontrollér, hvordan og hvornår møder kan bookes."
    },
    "payments": {
      "payments": "Betalinger",
      "payments_description": " Aktivér og administrer betalinger, regler og opkrævningsmodeller."
    },
    "extras": {
      "extras": "Tilpasninger",
      "extras_sub": "Samling Widget style og Andet Indstillinger.",
      "calendar_widget_style": "Stil for Widget",
      "neo": "Ny",
      "classic": "Klassisk",
      "insert_custom_code": "Indsæt Brugerdefineret kode",
      "show_seats_per_slot": "Vise Pladser pr. tidsrum",
      "allow_reschedule_meeting": "Aktivere Ændre Konferencer",
      "allow_cancelling_meeting": "Aktivere annullering af Konferencer",
      "additional_notes": "Yderligere noter",
      "cancellation_and_reschedule": "Afmelding og Ændre:",
      "allow_staff": "Aktivere personalevalg under booking",
      "code_block_tooltip": "Tredjepartsscripts Indre HTML blokken kan Tilbude kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at Du til anmeldelse Indhold af denne Kode Før Gemme det til kalenderen.",
      "calendar_image": "Kalender-coverbillede",
      "remove_image": "Uddrage Billede",
      "calendar_image_info": "Det uploadede billede vil være synligt i gruppevisningen for Neo-skabelonen og vil ikke blive vist på det individuelle kalenderlink.",
      "get_image_from_unsplash": "Forbedr dine billeder med",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Konfigurer yderligere præferencer",
      "service_image": "Service-coverbillede",
      "service_image_description": "Vælg et billede, der skal vises på servicemenuen for denne tjeneste.",
      "allow_reschedule_appointment": "Aktivere Ændre Aftale",
      "allow_cancelling_appointment": "Aktivere annullere Aftale",
      "custom_code_placeholder": "feedback Brugerdefineret kode her",
      "calendar_widget_style_desc": "Vælg mellem vores klassiske eller den stilfulde Neo-widget.",
      "seats_per_slot": "Pladser pr. . tidsrum",
      "show_staff_selection": "Personaleudvælgelse",
      "seats_per_slot_desc": " Aktive Booker til Vis nummer af tilgængelige Pladser pr. Tidsramme direkte Til kalender- Widget.",
      "show_staff_selection_desc": "Gør det muligt for bookere at vælge en medarbejder direkte fra kalender-widgetten under aftalebooking. Fungerer kun med Neo-widget.",
      "widget_re_order_tooltip": "Den klassiske widget-stil tillader ikke ændringer i widget-rækkefølge. Sørg for, at dato- og tidsvælgeren er først, og formularen er den anden, før du vælger den klassiske stil.",
      "show_staff_selection_desc_service": "Aktivere Booker for at vælge en medarbejdersmedlemmer direkte Fra kalender- Widget under Aftale-booking.",
      "switch_to_classic_widget": "Skift til klassisk widget",
      "switch_to_classic_widget_desc": "Ændring til <b>den klassiske widget</b> vil automatisk deaktivere følgende indstillinger, da de ikke kan sameksistere:",
      "form_first_disabled": "<b>Formularen flyttes til anden Trin</b> in Widget -sorteringen.",
      "appointment_preference_disabled": "<b>Ny præference for aftale (book altid med {contactLabel}s tildelte bruger)</b> vil blive deaktiveret. Dette betyder, at aftaler kan bookes med ethvert tilgængeligt gruppemedlem i stedet for at være begrænset til den {contactLabel}s tildelte bruger.",
      "multiple_location_disabled": "<b>Flere Konferencer-adresser</b> vil være Slettet, og kun den <b>først tilføjede placering</b> vil blive bevaret.",
      "insert_custom_code_tooltip": "Tilpas widget-styling ved hjælp af din egen CSS-kode.",
      "classic_tooltip_disabled": "Klassisk widget understøttes ikke til kalendere for klassebookinger.",
      "show_staff_selection_disabled_tooltip": "Personaleudvælgelse understøttes kun for neo-widget."
    },
    "roomsAndEquipments": {
      "title": "Vælg rum og udstyr",
      "description": "Vælg fra en liste over lokaler og udstyr, hvad der skal bookes sammen med denne kalender.",
      "rooms": "Vælg rum",
      "equipments": "Vælg udstyr"
    }
  },
  "activity_log": {
    "activity_log": "Aktivitetslog",
    "date": "Dato",
    "filter_by": "Filtrer efter",
    "calendar_update": "Opdatering af kalender",
    "start_time_update": "Opdatering af starttidspunkt",
    "end_time_update": "Opdatering af sluttidspunkt",
    "title_update": "Opdatering af titel",
    "notes_update": "Opdatering af noter",
    "appointment_status_update": "Opdatering af aftalestatus",
    "meeting_location_update": "Opdatering af mødested",
    "google_sync_update": "Opdatering af Google-synkronisering",
    "outlook_sync_update": "Opdatering af Outlook-synkronisering",
    "assigned_user_update": "Opdatering af tildelt bruger",
    "appointment_status": "Aftalestatus",
    "assigned_user": "Tildelt bruger",
    "uploaded_to": "Uploadet til",
    "cancelled": "Aflyst",
    "edited": "redigeret",
    "other_edits": "Andre redigeringer",
    "view_details": "Vis oplysninger",
    "all": "Alle"
  },
  "appointment_list": {
    "group_all": "ALLE",
    "group_primary": "PRIMÆR",
    "group_user": "BRUGERE",
    "group_team": "GRUPPER",
    "group_calendar": "KALENDERE",
    "all_appointments": "Alle aftaler",
    "my_calendar": "Min kalender",
    "status_all": "Alle",
    "status_confirmed": "Bekræftet",
    "status_new": "Ny (handling påkrævet)",
    "status_show": "Fremmødt",
    "status_no_show": "Udeblevet",
    "status_cancelled": "Aflyst",
    "status_invalid": "Ugyldig",
    "filter_date_added_desc": "Dato tilføjet (faldende)",
    "filter_start_added_desc": "Startdato (faldende)",
    "filter_start_added_asc": "Startdato stigende fra i dag",
    "button_new_appointment": "Ny aftale",
    "name": "Navn",
    "title": "Titel",
    "requested_time": "Ønsket tid",
    "date_added": "Dato tilføjet",
    "calendar": "Kalender",
    "appointment_owner": "Ejer af aftale",
    "notes": "Noter",
    "status": "Status",
    "action_view_detail": "Vis oplysninger",
    "action_view_consent": "Vis samtykke",
    "action_view_notes": "Vis noter",
    "action_edit": "Rediger",
    "action_delete": "Slet",
    "action_reschedule": "Ændr",
    "page_previous": "Tidligere",
    "page_next": "Næste",
    "appointment_notes": "Noter til aftaler",
    "close": "Luk",
    "confirm_delete_header": "Slet aftale",
    "confirm_delete_message": "Er du sikker på, at du vil slette denne aftale?  Denne handling kan ikke fortrydes!",
    "confirm_delete_button": "Slet",
    "confirm_update_header": "Opdater aftalestatus",
    "confirm_update_confirmed_message": "Er du sikker på, at du vil markere denne aftale som bekræftet?",
    "confirm_update_invalid_message": "Er du sikker på, at du vil markere denne aftale som ugyldig?",
    "confirm_update_showed_message": "Er du sikker på, at du vil markere denne aftale som fremmødt?",
    "confirm_update_noshow_message": "Er du sikker på, at du vil markere denne aftale som udeblevet?",
    "confirm_update_cancelled_message": "Er du sikker på, at du vil markere denne aftale som annulleret?",
    "confirm_update_button": "Opdater",
    "empty_state_title": "Der blev ikke fundet nogen aftaler",
    "empty_state_description": "Ingen aftaler fundet.",
    "disable_menu_warning": "Du har ikke tilladelse til at se eller redigere aftalens oplysninger, da den tilknyttede kontakt ikke er tildelt dig. Kontakt din admin for at få hjælp.",
    "no_contact_warning": "Du kan ikke få adgang til kontaktoplysninger i øjeblikket. Dette kan skyldes, at kontakten ikke er tildelt dig. Kontakt din admin for at få hjælp.",
    "consent_label": "Samtykke",
    "ip_address": "IP",
    "youre_viewing_in": "Vises i øjeblikket i",
    "appointment_delete_msg": "<b>Bemærk:</b> Aftalen, der slettes herfra, vil ikke blive slettet fra Calendly.",
    "rescheduled": "Ændret"
  },
  "add_guest": {
    "guest_label": "Gæst(er)",
    "search_placeholder": "Søge Fra Venner",
    "add_new": "Tilføj ny",
    "save": "Arkiv",
    "close": "Luk",
    "name": "Navn",
    "phone": "Telefon",
    "email": "E-mail",
    "guest_label_count": "Gæst(s) Optælling",
    "guest_count_error": "Gæst Optælling skal være mellem 1 og 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Detaljer om servicemenu",
    "select_groups_header": "Vælg tjenester",
    "arrange_groups_header": "Konfigurer din Serviceydelser",
    "new_service_menu": "Ny servicemenu",
    "service_menu_sub_title": "Åbn en Tilpasset servicemenu til din Kunder in kun få klik",
    "quick_tip": "Du kan Inkludere Gruppe til servicemenu",
    "service_menu_name": "Servicemenu navn",
    "service_menu_description": "Beskrivelse",
    "service_menu_slug": "URL til service",
    "select_groups_calendars": "Vælge gruppe og kalendere",
    "select_groups_calendars_desc": "Tilføj serviceydelser til din servicemenu",
    "select_all": "Vælg alle",
    "arrange_groups": "Konfigurer Sortere af Serviceydelser",
    "arrange_groups_desc": "Bestem Proces af Serviceydelser Til servicemenuen",
    "arrange_services_quicktip": "For at Ændre kalendere i Gruppe skal du gå til Gruppe > Valgmuligheder > Ændre Kalendere.",
    "enable_add_guest_desc": "Aktivere Kunder at Inkludere yderligere gæster, når du foretager en booking.",
    "enable_multiple_service_desc": "Aktivere Kunder til at Book flere Serviceydelser in en individuel Aftale.",
    "enable_staff_selection_desc": "Aktivere Kunder til at vælge foretrukket personale Medlemmer Når du booker.",
    "enable_add_guest": "Aktivér tilføj gæster",
    "enable_multiple_service": "Aktivér flere tjenestevalg",
    "enable_staff_selection": "Gør det muligt at vælge personale",
    "additional_options": "Yderligere muligheder",
    "code_block_tooltip": "Tredjepartsscripts Indre HTML blokken kan Tilbude kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at Du til anmeldelse Indhold af denne Kode Før Gemme den til servicemenuen.",
    "custom_code_placeholder": "feedback Brugerdefineret kode her",
    "insert_custom_code": "Indsæt Brugerdefineret kode",
    "no_service": "Der blev ikke fundet nogen service",
    "no_service_desc": " Ingen Serviceydelser fundet. Opret Serviceydelser og Inkludere dem til Gruppe for at Opret en servicemenu.",
    "learn_more": "Få mere at vide",
    "no_service_selected": "Ingen service Valgt",
    "create_service_calendars": "Opret servicekalendere",
    "alert_description": " For at oprette en servicemenu skal du oprette bookingkalendere og tilføje dem til grupper.",
    "dont_show_again": "Vis ikke dette igen",
    "service_name_required": "Navn på servicemenu er påkrævet",
    "slug_already_taken": "Denne Slug er allerede taget",
    "slug_required": "Slug er Påkrævet",
    "please_enter_name": "Indtast et navn",
    "service_name_placeholder": "Hovedmenu",
    "service_slug_placeholder": "hovedmenu",
    "form_label": "Formular",
    "consent_label": "Samtykke Afkrydsningsfelt",
    "consent_input_placeholder": "Tilføj samtykketekst",
    "consent_tooltip": "Aktivér denne indstilling for at tillade indhentning af samtykke fra {contactsLabel}, når de angiver deres telefonnummer under aftalebookingprocessen.",
    "back_message": "Gå tilbage til listen",
    "saving_changes": "Kun et minut — Gemme den seneste Dynamisk ...",
    "payment_provider_warning": "Bemærk! Servicemenuer understøtter i øjeblikket kun betalinger via Stripe og Authorize.net. Da din standardudbyder afviger, vil betalingsopkrævning for valgte kalendere med aktiverede betalinger blive sprunget over.",
    "aria": {
      "consent_form_toggle": "Aktivér samtykkeformular",
      "enable_add_guest_toggle": "Aktivér tilføj gæst",
      "enable_multiple_services_toggle": "Aktivér flere tjenester",
      "enable_staff_selection_toggle": "Aktivér valg af personale"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Tilpas-kalender- Widget",
    "works_with_neo_widget": "Fungerer kun med Neo Widget",
    "customise_widget_desc": "Tilpas Widget Udseende: PRIMÆR Farve, Baggrund Farve og Knap Indhold.",
    "learn_more": "Få mere at vide",
    "primary_settings": "PRIMÆR Indstillinger",
    "primary_settings_desc": "Konfigurer primærfarven, baggrundsfarven og andre widget-præferencer for at tilpasse din kalender-widget.",
    "primary_color": "PRIMÆR Farve",
    "primary_color_desc": "Definer farven for knapper, datoer, tidsrum og handlinger.",
    "background_color": "Baggrund Farve",
    "background_color_desc": "Samling af Baggrund Farve, der fungerer som baggrund for både datotime og Formular.",
    "button_text": "Knaptekst",
    "button_text_desc": "Tilpas teksten, der vises på knappen, når der bookes en aftale.",
    "calendar_title": "Kalendertitel",
    "calendar_title_desc": "Navnet på din kalender",
    "calendar_description": "Kalenderbeskrivelse",
    "calendar_description_desc": "Den indtastede beskrivelse.",
    "calendar_details": "Kalenderoplysninger",
    "calendar_details_desc": "Indeholder oplysninger såsom varighed, dato og tidspunkt, tilbagevendende detaljer og tidszone.",
    "reset_to_default": "Nulstille til Standard",
    "preview_widget": "Forhåndsvisningswidget",
    "calendar_title_tooltip": "Angiv, om kalendernavnet og gruppenavnet (hvis relevant) skal være synlige på booking-widgetten.",
    "calendar_description_tooltip": "Angiv, om kalenderbeskrivelsen skal være synlig på booking-widgeten.",
    "calendar_details_tooltip": "Samling Hvis de Vigtige møder Oplysninger som Konferencer Varighed, Valgt Dato & Dato og gentagelsesinfo (hvis det er relevant) skal være synlige frem til Booking-widgeten.",
    "insert_custom_code_tooltip": "Tilpas Widget -styling Via din egen CSS kode.",
    "staff_selection_tooltip": "Aktivere Booker for at vælge en medarbejdersmedlemmer direkte Fra kalender- Widget under Aftale-booking. Fungerer kun med Neo Widget."
  },
  "eventNotification": {
    "customFields": "Brugerdefinerede felter",
    "customValues": "Brugerdefinerede værdier",
    "templateVariableIssueDefaultPartBefore": "Der er problemer med dine ",
    "templateVariableIssueDefaultPartHighlight": "brugerdefinerede værdier",
    "templateVariableIssueDefaultPartAfter": "Gennemgå og ret dem, før du gemmer.",
    "templateVariableInvalidListOverflow": "… og {count} flere",
    "templateVariableIssueSingle": "Der er et problem med denne brugerdefinerede værdi: {value}. Ret den, før du gemmer.",
    "templateVariableIssueEmpty": "En eller flere brugerdefinerede værdier er tomme ({emptyPair}). Tilføj et gyldigt felt inden for parenteserne.",
    "templateVariableIssueMarkup": "Nogle brugerdefinerede værdier inkluderer HTML eller formatering, som ikke understøttes. Fjern det, før du gemmer.",
    "templateVariableSaveFailed": "Kunne ikke gemme {receiverLabel}-notifikation. Ret fejl i brugerdefinerede værdier, før du gemmer.",
    "templateVariableSaveFailedGeneric": "Kunne ikke gemme notifikationen. Ret fejl i brugerdefinerede værdier, før du gemmer.",
    "guest": "Gæst",
    "assignedUser": "Tildelt bruger",
    "additionalEmails": "Yderligere e-mailadresser",
    "list": {
      "booked": {
        "title": "Aftale booket (Status: Ubekræftet)",
        "modalTitle": "Aftale booket (Status: Ubekræftet)",
        "note": "Denne meddelelse sendes, når der oprettes en ny aftale med statussen Ubekræftet.",
        "subTitle": "Giver besked, når en aftale er booket med en ubekræftet status."
      },
      "confirmation": {
        "title": "Aftale booket (Status: bekræftet)",
        "modalTitle": "Aftale booket (Status: bekræftet)",
        "note": "Denne meddelelse sendes, når der oprettes en aftale med eller opdateres til statussen Bekræftet.",
        "subTitle": "Giver besked, når en aftale er bekræftet."
      },
      "cancellation": {
        "title": "Annullering",
        "modalTitle": "Annullering",
        "note": "Denne meddelelse sendes, når en aftale annulleres, markeres som udeblevet eller markeres som ugyldig.",
        "subTitle": "Advarer om, at en aftale er blevet aflyst."
      },
      "reschedule": {
        "title": "Ændr",
        "modalTitle": "omplanlæg",
        "note": "Denne notifikation sendes, når en Aftale omlægges. Den udløses kun, hvis Aftale in Status ubekræftet eller Bekræftet.",
        "subTitle": "Giver besked, når en aftale ændres"
      },
      "reminder": {
        "title": "Påmindelse",
        "modalTitle": "påmindelse",
        "note": "Denne Notifikation sendes som en Påmindelse Før the Aftale. Den udløses kun, hvis Aftale in Status ubekræftet eller Bekræftet.",
        "subTitle": "Sender en påmindelse inden aftalen."
      },
      "followup": {
        "title": "Opfølgning",
        "modalTitle": "opfølgning",
        "note": "Denne meddelelse sendes efter aftalen som en opfølgning. Det udløses kun, hvis aftalen har statussen Ubekræftet, Bekræftet eller Fremmødt.",
        "subTitle": "Sender en opfølgningsbesked efter aftalen er gennemført."
      }
    },
    "saveToastMsg": "Indstillingerne blev gemt!",
    "saveToastMsgDesc": "Dine ændringer er blevet gemt",
    "enableSuccess": "Notifikationer aktiveret!",
    "disableSuccess": "Notifikationer er deaktiveret!",
    "tooltip": "Denne meddelelse er blevet deaktiveret. Aktivér den for at foretage eventuelle ændringer.",
    "enabled": "Aktiveret",
    "disabled": "Deaktiveret",
    "statusLabel": "Bemærk etiketter",
    "email": {
      "channelName": "E-mail",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send testmail",
      "testEmailLabel": "Testmail",
      "testEmailPlaceholder": "Indtast modtagerens e-mailadresse til testformål",
      "body": "E-mailindhold",
      "bodyPlaceholder": "Skriv din besked her",
      "subject": "Emne",
      "subjectPlaceholder": "Indtast e-mailens emne",
      "templateLabel": "E-mailskabelon",
      "templatePlaceholder": "Vælg en e-mailskabelon, eller start fra bunden",
      "fromNamePlaceholder": "Indtast navn",
      "fromNameLabel": "Fra navn",
      "fromAddressLabel": "Fra-adresse",
      "alertEmailAddress": "Indtast e-mailadresser (adskilt af kommaer)",
      "addMore": "Tilføj mere",
      "afterAppointmentEnds": "efter aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "disableEmailNotification": "Deaktiver e-mailnotifikationer",
      "enableEmailNotification": "Aktivér e-mailnotifikationer",
      "enableSuccess": "E-mailnotifikation aktiveret!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation",
      "disableSuccess": "E-mailnotifikation deaktiveret!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation",
      "reset_to_default": "Nulstille til Standard",
      "testEmailSuccessTitle": "Testmail sendt!",
      "testEmailSuccessDesc": "En testmail er blevet sendt til {email}",
      "testEmailErrorTitle": "Kunne ikke sende en test-e-mail",
      "testEmailErrorDesc": "Der opstod en fejl under afsendelse af testmailen. Prøv igen.",
      "create_new_email_template": "Opret ny e-mailskabelon",
      "templateVariableFieldSubject": "Emnelinje",
      "templateVariableFieldFromName": "Fra-navn",
      "templateVariableFieldFromAddress": "Fra-adresse",
      "templateVariableFieldEmailBody": "E-mailindhold"
    },
    "inApp": {
      "channelName": "I appen",
      "title": "Notifikationsindstillinger",
      "enableInAppNotification": "Aktivér app-notifikationer",
      "disableInAppNotification": "Deaktiver app-notifikation",
      "selectedUser": {
        "label": "Send til",
        "helperText": "Denne interne notifikation sendes via web-apps og mobile apps.",
        "placeholder": "Vælg bruger(e)"
      },
      "enableSuccess": "Notifikationer i appen er aktiveret!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation.",
      "disableSuccess": "App-notifikationer deaktiverede!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Ingen",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send test-sms",
      "testSMSLabel": "Test-sms (indtast telefonnummer med landekode)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS-besked",
      "bodyPlaceholder": "Skriv din SMS-besked her",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "disableSMSNotification": "Deaktiver SMS-notifikationer",
      "enableSMSNotification": "Aktivér SMS-notifikationer",
      "enableSuccess": "SMS-notifikation aktiveret!",
      "enableSuccessDesc": "Du vil nu begynde at modtage denne notifikation.",
      "disableSuccess": "SMS-notifikation deaktiveret!",
      "disableSuccessDesc": "Du vil ikke længere modtage denne notifikation.",
      "alertPhoneNumbers": "Indtast telefonnumre (med landekoder, adskilt af kommaer)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Tilføj flere",
      "afterAppointmentEnds": "når aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "templateLabel": "SMS-skabelon",
      "templatePlaceholder": "Vælg SMS-skabelon...",
      "reset_to_default": "Nulstil til standard",
      "testSmsSuccessTitle": "Test-SMS sendt!",
      "testSmsSuccessDesc": "En test-SMS er blevet sendt til {phone}.",
      "testSmsErrorTitle": "Det lykkedes ikke at sende en test-sms",
      "testSmsErrorDesc": "Der opstod en fejl under afsendelse af test-SMS'en. Prøv igen.",
      "templateVariableFieldSmsBody": "Beskedens indhold"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Hvem skal modtage denne notifikation?",
      "sendButtonLabel": "Send testnotifikation via WhatsApp",
      "testWhatsAppLabel": "Test WhatsApp-notifikation (indtast telefonnummer med landekode)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Hvornår vil du udløse notifikationen?",
      "alertPhoneNumbers": "Indtast telefonnumre (med landekoder adskilt af kommaer)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Tilføj flere",
      "afterAppointmentEnds": "når aftalen slutter",
      "beforeAppointmentStarts": "før aftalen begynder",
      "templateLabel": "WhatsApp-skabelon",
      "templatePlaceholder": "Vælg WhatsApp-skabelon...",
      "noPreview": "Ingen skabelon er valgt",
      "documentPreview": "Dokument",
      "offerEndsOn": "Tilbuddet slutter den {date}",
      "offerCode": "Kode: {code}",
      "templateRequired": "Skabelon er påkrævet",
      "testWhatsAppSuccessTitle": "Testnotifikation via WhatsApp sendt!",
      "testWhatsAppSuccessDesc": "En testnotifikation via WhatsApp er blevet sendt til {phone}.",
      "testWhatsAppErrorTitle": "Kunne ikke sende testnotifikation via WhatsApp.",
      "testWhatsAppErrorDesc": "Der opstod en fejl under afsendelse af testnotifikationen via WhatsApp. Prøv igen.",
      "setupTitle": "Nå ud til din kunde på deres foretrukne besked-app.",
      "setupDescription": "Hold kontakten med dine kunder ved at levere øjeblikkelig support, sende rettidige opdateringer og skabe engagerende interaktioner.",
      "connectWhatsApp": "Forbind WhatsApp",
      "checkingStatus": "Kontrollerer WhatsApp-kontoens status...",
      "checkingTemplateStatus": "Tjekker WhatsApp-skabelonbemærk...",
      "statusCheckError": "Det lykkedes ikke at kontrollere WhatsApp-kontoens status.",
      "templateStatusCheckError": "Kunne ikke kontrollere WhatsApp-skabelonens bemærk.",
      "setupTemplateTitle": "Fuldfør din WhatsApp-skabelonopsætning.",
      "setupTemplateDescription": "Du skal Konfigurer WhatsApp-skabeloner, Før du kan Upload notifikationer. Klik nedenfor for at fuldføre opsætningsprocessen.",
      "loadTemplatesError": "Det lykkedes ikke at indlæse WhatsApp-skabeloner.",
      "templatesRefreshed": "Skabelonerne er blevet opdateret",
      "templatesRefreshError": "Skabelonerne kunne ikke opdateres.",
      "templatesResolveError": "Det lykkedes ikke at løse WhatsApp-standardskabeloner.",
      "locationNotFound": "Lokations-ID ikke fundet.",
      "settingsRedirectError": "Kan ikke omdirigere til WhatsApp-indstillinger.",
      "updateNotificationError": "Kunne ikke opdatere WhatsApp-notifikation.",
      "notificationsEnabled": "WhatsApp-notifikationer aktiveret!",
      "notificationsDisabled": "WhatsApp-notifikationer er deaktiveret!",
      "updateError": "Fejl ved opdatering af notifikationer.",
      "createNewTemplate": "Opret en ny WhatsApp-skabelon",
      "phoneValidation": {
        "countryCodeRequired": "Telefonnummeret skal starte med en landekode (f.eks. +1, +91, +44)",
        "digitsOnly": "Telefonnummer må kun indeholde cifre efter landekoden.",
        "tooShort": "Telefonnummeret er for kort.",
        "tooLong": "Telefonnummeret er for langt.",
        "invalid": "Ugyldigt telefonnummer."
      },
      "errors": {
        "templateNotFound": "Skabelon-id blev ikke fundet i indlæste valgmuligheder, rydder.",
        "templateNoLongerValid": "Den gemte skabelon er ikke længere gyldig, rydder.",
        "invalidTemplateSelection": "Forsøgte at vælge en ugyldig WhatsApp-skabelon.",
        "fetchingTemplates": "Fejl under hentning af WhatsApp-skabeloner.",
        "mountingCreator": "Fejl ved montering af WhatsApp-skabelonopretter.",
        "fetchingAfterCreation": "Fejl ved hentning af WhatsApp-skabeloner efter oprettelse.",
        "updateStatus": "Fejl under opdatering af WhatsApp-status."
      },
      "receiverLabels": {
        "assignedUser": "Tildelt bruger",
        "phoneNumbers": "Yderligere telefonnumre"
      }
    },
    "voiceAi": {
      "channelName": "Voice AI",
      "setupTitle": "Afslut opsætningen af Voice AI",
      "setupDescription": "Voice AI-påmindelser kræver, at nogle få ting er på plads, før du kan konfigurere dem.",
      "agentLabel": "Stemmeagent",
      "agentPlaceholder": "Vælg en agent",
      "agentHelper": "Agenten, der foretager påmindelsesopkaldet. Hvis den endnu ikke er live, gør du den live ved at gemme denne påmindelse.",
      "openAgent": "Åbn agent",
      "createAgent": "Opret påmindelsesagent",
      "creatingAgent": "Opretter…",
      "createAgentHelper": "Ny her? Opret en agent, der er sat op til denne kalender: booking, ombooking og aflysning samt en påmindelseshilsen, du kan redigere.",
      "agentCreated": "Påmindelsesagenten er oprettet og valgt. Gennemgå dens hilsen og stemme i agentbuilderen.",
      "agentCreateFailed": "Påmindelsesagenten kunne ikke oprettes. Prøv igen.",
      "agentCreateNoPermission": "Du har ikke tilladelse til at oprette Voice AI-agenter. Bed en administrator om at oprette en.",
      "requirements": {
        "title": "Før påmindelsesopkald sendes",
        "booking": "Agenten skal have en handling til aftalebooking for denne kalender med ombooking og aflysning slået til, så den kan finde og ændre den aftale, den ringer om. En agent, der er oprettet her, har dette allerede.",
        "greeting": "Opkaldet starter med agentens udgående hilsen, som den er indstillet på agenten. Aftalen er tilgængelig for agenten via flettefelter som {start} og {calendar}.",
        "dismiss": "Afvis"
      },
      "fromNumberLabel": "Ring fra",
      "fromNumberPlaceholder": "Vælg et nummer",
      "timingLabel": "Hvornår skal opkaldet foretages?",
      "beforeAppointment": "før aftalen starter",
      "timingHelper": "Opkald foretages mellem kl. 8 og 20 i kontaktens lokale tid. Med denne indstilling ringes der til aftaler, der starter mellem {from} og {until}.",
      "timingRangeError": "Vælg mellem {min} og {max} {unit}.",
      "units": {
        "day": "dag",
        "days": "dage"
      },
      "consent": {
        "label": "Jeg accepterer vilkårene for udgående opkald",
        "updatedLabel": "Jeg accepterer de opdaterede vilkår for udgående opkald",
        "note": "Du bliver kun spurgt én gang for denne lokation.",
        "updatedNote": "Vilkårene er ændret, siden du sidst accepterede dem. Det er valgfrit at acceptere.",
        "termsTitle": "Vilkår og betingelser",
        "termsIntro": "By activating this feature, you confirm and agree that your business:",
        "terms1": "Will not use this feature in violation of applicable laws governing the making and sending of calls, including but not limited to the Telephone Consumer Protection Act (TCPA), the Telemarketing Sales Rule (TSR), applicable state telemarketing laws, and any equivalent international laws and regulations applicable to your use.",
        "terms2": "Has secured the correct level of consent from each individual before placing calls.",
        "terms3": "Is solely responsible for your compliant use of this functionality.",
        "required": "Accepter vilkårene for udgående opkald for at aktivere Voice AI-påmindelser."
      },
      "guidelines": {
        "title": "Sådan fungerer påmindelsesopkald",
        "window": "Der ringes kun mellem kl. 8 og 20 i kontaktens lokale tid, som udledes af telefonnummeret.",
        "oncePerDay": "Hver kontakt ringes højst op én gang om dagen, så der foretages ét påmindelsesopkald pr. aftale.",
        "queued": "Opkald sættes i kø, så opringningen kan begynde nogle minutter efter påmindelsestidspunktet.",
        "skips": "Kontakter, der har fravalgt AI-opkald eller har Forstyr ikke slået til, springes over.",
        "country": "Der ringes kun til numre i denne kontos eget land.",
        "fallback": "Hvis opkaldet ikke kan foretages eller ikke besvares, sendes {channel}-påmindelsen i stedet.",
        "capabilities": "Hvis agentens aftalebooking har flytning og aflysning slået til, kan kunden flytte eller aflyse under opkaldet."
      },
      "blockers": {
        "noAgent": "Publicer mindst en stemmeagent.",
        "noNumber": "Tilføj et telefonnummer for opkald skal komme fra.",
        "notEnabled": "Aktivér Voice AI for denne konto."
      },
      "agentRequired": "Vælg en agent til at foretage påmindelsesopkaldet.",
      "fromNumberRequired": "Vælg det nummer, påmindelsesopkaldet skal komme fra.",
      "saveError": "Voice AI-påmindelsesindstillingerne kunne ikke gemmes. Prøv igen."
    }
  },
  "smsTemplate": {
    "create_new_template": "Opret ny SMS-skabelon",
    "create_new_template_desc": "Opret en genanvendelig SMS-skabelon til dine notifikationer.",
    "template_name": "Skabelonnavn",
    "template_name_placeholder": "Indtast skabelonnavn",
    "message": "Besked",
    "message_placeholder": "Skriv din SMS-besked her.",
    "create_template": "Opret skabelon",
    "name_required": "Skabelonnavn er påkrævet",
    "text_required": "Beskedtekst er påkrævet",
    "fetch_new_templates": "Opdater skabeloner",
    "characters": "tegn",
    "words": "ord",
    "segments": "segmenter"
  },
  "whatsappTemplate": {
    "create_new_template": "Opret ny WhatsApp-skabelon",
    "create_new_template_desc": "Opret en genanvendelig WhatsApp-skabelon til dine notifikationer.",
    "template_name": "Skabelonnavn",
    "template_name_placeholder": "Indtast skabelonnavn",
    "message": "Besked",
    "message_placeholder": "Skriv din WhatsApp-besked her.",
    "create_template": "Opret skabelon",
    "name_required": "Skabelonnavn er påkrævet",
    "text_required": "Beskedtekst er påkrævet",
    "fetch_new_templates": "Opdater skabeloner"
  },
  "archivedServices": {
    "servicesBanner": "En ny, opgraderet version af tjenesterne er her – mere kraftfuld, fleksibel og intuitiv. Dine bookingkalendere er allerede blevet migreret. Udforsk dem nu i fanen Tjenester.",
    "archivedServiceCalendars": "Bookingkalendere (v1)",
    "check_new_services": "Tjek nye serviceydelser"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Rediger kalender",
      "share_calendar": "Del kalender",
      "troubleshoot_calendar": "Fejlfinding af kalender",
      "more_options": "Flere muligheder",
      "edit_calendar_desc": "Administrer hver kalenderindstillinger—Fast Tilgængelighed, Konfigurer Påmindelse, Ændre Aftale grænser og mere.",
      "share_calendar_desc": "Kopiér og Slet dit Link til planlægning, så Booker nemt kan skema med Du.",
      "troubleshoot_calendar_desc": "Find ud af, hvorfor et tidsrum ikke vises, og se mulige årsager i fejlfindingsvisningen.",
      "more_options_desc": "Få adgang til yderligere indstillinger og aktiviteter til at administrere din kalender.",
      "read_permissions": {
        "share_description": "Giv andre adgang ved at dele kalenderlinket eller justere tilladelserne.",
        "troubleshoot_description": "Identificer og løs problemer som synkroniseringsfejl eller manglende hændelser for at sikre problemfri funktionalitet."
      },
      "next": "Næste",
      "start_over": "Start forfra",
      "all_set": "Sådan!",
      "previous": "Tidligere"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Vælg din redigeringsoplevelse",
    "select_editing_experience_desc": "Vælg at bygge ved hjælp af vores visuelle træk-og-slip-designeditor eller stærke kodeeditor.",
    "design_editor": "Designeditor",
    "design_editor_desc": "Visuel, træk-og-slip-redigering.",
    "code_editor": "Kodeeditor",
    "code_editor_desc": "Funktionsrig HTML-redigering.",
    "text_editor": "Kodeeditor til almindelig tekst",
    "text_editor_desc": "Grundlæggende, enkelt tekstredigering, uden dikkedarer.",
    "email_text_block": "E-mail kan også oprettes Via Indhold Spær. ",
    "select": "Vælge",
    "new_template": "Ny skabelon",
    "email_block": "E-mail kan også oprettes ved hjælp af en tekstblok.",
    "fetch_new_templates": "Hent nye skabeloner"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Brug et klart mødenavn og en klar mødebeskrivelse, så bookerne ved præcis, hvad de skemalægger.",
      "groups_share_link": "Grupper giver dig mulighed for at dele et enkelt link til planlægning til flere kalendere, så kunderne kan vælge og booke blandt de tilgængelige muligheder."
    },
    "staff_location": {
      "custom_location": "Vælg 'Brugerdefineret' som mødeplacering for at indtaste en valgfri adresse eller et link efter eget valg.",
      "ask_booker_location": "Når 'Ask the Booker' er valgt, bliver bookeren bedt om at indtaste mødeplaceringen under bookingen",
      "round_robin_priority": "Prioritetsindstillinger påvirker, hvordan møder fordeles, når flere medarbejdere er til rådighed.",
      "connect_video_integrations": "Forbind videokonferenceintegrationer fra kalenderindstillinger → forbindelser, inden du vælger dem som mødeplacering."
    },
    "availability": {
      "staff_availability_required": "Møder kan kun bookes, når mindst én valgt medarbejder er tilgængelig.",
      "use_precreated_schedule": "Du kan bruge en forudoprettet tilgængelighedsplan fra Kalenderindstillinger → Tilgængelighed eller oprette et brugerdefineret skema kun til denne kalender.",
      "timezone_in_schedule": "Tidszonen for møder er indstillet inden for den valgte tilgængelighedsskema.",
      "event_24_hours": "For at gøre kalenderen tilgængelig i 24 t. skal du angive tidsintervallet fra kl. 00 til 00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Bookingregler gælder for alle møder i denne kalender, uanset om medarbejderne er tilgængelige.",
      "minimum_scheduling_notice": "Forøg minimums skemavarsel for at forhindre bookinger i sidste øjeblik.",
      "maximum_bookings_per_slot": "Brug maksimalt antal bookinger pr. tidsrum til at styre, hvor mange møder der kan finde sted samtidig."
    },
    "forms": {
      "custom_contact_fields": "Du kan inkludere brugerdefinerede kontaktfelter i både formularmeddelelser og formular-URL'er.",
      "create_custom_form": "For at indsamle flere oplysninger skal du oprette en brugerdefineret formular fra Sites → Forms → Builder og bruge den med denne kalender."
    },
    "payments": {
      "collected_during_booking": "Betalinger opkræves under bookingen og skal være gennemført, før mødet bekræftes.",
      "payment_description": "Brug betalingsbeskrivelsen til tydeligt at forklare, hvad opkrævningen er for."
    },
    "notifications": {
      "review_policies": "Gennemgå aflysnings- og omplanlægningspolitikker for at undgå ændringer i sidste øjeblik.",
      "use_workflows": "Til avanceret automatisering, brug arbejdsgange med udløseren 'Aftale booket'."
    },
    "customizations": {
      "preview_widget": "Forhåndsvis widgetten for at sikre, at den passer til dit brand og bookingflow.",
      "update_widget_language": "Sprogindstillinger for widgetten kan ændres fra Indstillinger → Kalendere → Præferencer."
    },
    "connections": {
      "google_organic_booking": "Opsætning af Google Organic Booking gør det muligt for denne kalender at modtage bookinger direkte fra Google Søgning.",
      "external_sync_event": "Kun den kalender, der er valgt under Ekstern synkronisering, anvendes til at hente og overføre begivenheder for denne kalender."
    },
    "equipments": {
      "room_definition": "Et 'rum' kan repræsentere ethvert sted, hvor tjenester leveres. Dette kunne være fysiske rum og/eller dedikerede stationer. F.eks. pedicurestation.",
      "equipment_definition": "Tænk på 'udstyr' som ethvert værktøj eller enhver enhed, som virksomheder bruger til at opfylde aftaler. Dette kan omfatte maskiner, apparater eller endda stole."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Fastgjorte kontakter",
    "consent_form": "Samtykkeformular",
    "enable_guests": "Aktivér gæster",
    "auto_confirm": "Automatisk bekræftelse",
    "should_accept_payment": "Skal acceptere betaling",
    "collect_deposit": "Opkræv depositum",
    "enable_charge_guests": "Aktivér opkrævning af gæster",
    "enable_coupon": "Aktivér kupon",
    "payment_live": "Live-betaling",
    "add_availability_hour": "Tilføj tilgængelige timer",
    "remove_availability_hour": "Fjern tilgængelige timer",
    "copy_availability_hour": "Kopiér tilgængelighedstime",
    "close_modal": "Luk modal",
    "add_custom_slot": "Tilføj tilpasset tidsrum",
    "remove_custom_slot": "Fjern tilpasset tidsrum",
    "edit_custom_slot": "Rediger tilpasset tidsrum",
    "update_frequency": "Opdateringsfrekvens",
    "show_calendar_title": "Vis kalendertitel",
    "show_calendar_description": "Vis kalenderbeskrivelse",
    "show_calendar_details": "Vis kalenderoplysninger",
    "allow_reschedule": "Tillad ændring",
    "allow_cancellation": "Tillad annullering",
    "category_actions": "Kategori-handlinger",
    "show_seats_per_slot": "Vis pladser pr. tidsrum",
    "add_more": "Tilføj flere",
    "same_user_assignment_toggle": "Skift til samme brugertildeling"
  },
  "placeholders": {
    "pixel_id": "Pixel-id",
    "select_one": "Vælg en",
    "meeting_location": "Mødested",
    "schedule_meeting": "Planlæg møde",
    "notes": "Noter",
    "select_users": "Vælg brugere",
    "please_select": "Vælg"
  },
  "alt_text": {
    "payment_provider": "Betalingsudbyder",
    "no_calendars": "Ingen kalendere",
    "date_specific_hours": "datospecifikke-timer",
    "custom_widget_image": "Tilpasset widget-billede",
    "service_calendar": "Bookingkalender",
    "event_calendar": "Begivenhedskalender",
    "round_robin_booking": "Booking med automatisk tildeling af aftaler",
    "class_booking": "Klassebooking",
    "collective_booking": "Gruppebooking",
    "calendar_cover_image": "Kalender-coverbillede",
    "email_notification_switch": "Skift til e-mailnotifikationer",
    "email_template_icon": "E-mailskabelon-ikon",
    "in_app_notification_switch": "Notifikationskontakt i appen",
    "sms_notification_switch": "Skift til SMS-notifikation",
    "whatsapp_notification_switch": "Skift til WhatsApp-meddelelser",
    "no_service_found": "Der blev ikke fundet nogen serviceydelser",
    "no_group_found": "Der blev ikke fundet nogen grupper",
    "sync_icon": "Synkroniseringsikon",
    "sync_type": "Synkroniseringstype",
    "test1": "test1",
    "test2": "test2",
    "voice_ai_notification_switch": "Voice AI-påmindelses-switch"
  },
  "tooltips": {
    "text_color": "Tekstfarve",
    "background_color": "Baggrundsfarve",
    "strikethrough": "Gennemstreget tekst",
    "superscript": "Hævet skrift",
    "subscript": "Sænket skrift",
    "inline_code_block": "Indbygget kodemodul",
    "code_block": "Kodemodul",
    "block_quote": "Modulcitat",
    "more": "Mere",
    "upload": "Upload",
    "image_upload_tooltip": "PNG, JPEG, JPG eller GIF (maks. dimensioner 180x180px | maks. størrelse 2,5 MB)",
    "custom_values": "brugerdefinerede værdier",
    "text_wrap": "Tekstombrydning",
    "trigger_links": "aktiveringslinks",
    "text_align": "Tekstjustering"
  },
  "labels": {
    "reset_style": "Nulstil stil",
    "reset_document_style": "Nulstil dokumentets stil",
    "source_code": "Kildekode",
    "success": "Gennemført",
    "edit": "Rediger",
    "submit": "Gem",
    "cancel": "Annuller",
    "payment": "Betaling",
    "here_is_the_link": "Her er linket:",
    "here_is_the_embed_code": "Her er indlejringskoden:",
    "service_calendar": "Bookingkalender",
    "collective_booking": "Gruppebooking",
    "class_booking": "Klassebooking",
    "round_robin_booking": "Automatisk tildeling af aftaler",
    "event_calendar": "Kalender for begivenheder",
    "personal_booking": "Personlig booking",
    "service_booking": "Servicebooking",
    "calendar_id": "Kalender-id"
  },
  "validation_messages": {
    "calendar_group_name_required": "Kalendergruppens navn er påkrævet.",
    "calendar_group_description_required": "Beskrivelsen af kalendergruppen er påkrævet.",
    "slug_required": "Slug er påkrævet.",
    "slug_not_valid": "Denne slug er ikke gyldig.",
    "slug_already_taken": "Denne slug er allerede optaget.",
    "error_validating_slug": "Fejl ved validering af slug.",
    "please_enter_name": "Indtast et navn.",
    "room_name_required": "Navn på rum er påkrævet",
    "equipment_name_required": "Udstyrets navn er påkrævet.",
    "subject_required": "Emne er påkrævet",
    "this_is_required": "Dette er nødvendigt.",
    "calendar_group_slug_required": "Kalendergruppens slug er påkrævet.",
    "capacity_mandatory": "Kapacitet er påkrævet.",
    "capacity_cannot_be_zero": "Kapaciteten må ikke være nul.",
    "capacity_should_be_a_number": "Kapaciteten skal være et tal.",
    "capacity_cannot_be_negative": "Kapaciteten må ikke være negativ.",
    "capacity_should_be_a_whole_number": "Kapaciteten skal være et helt tal.",
    "quantity_mandatory": "Mængde er påkrævet",
    "quantity_cannot_be_zero": "Mængden må ikke være nul.",
    "quantity_should_be_a_number": "Mængden skal være et tal.",
    "quantity_cannot_be_negative": "Mængden må ikke være negativ.",
    "quantity_should_be_a_whole_number": "Mængden skal være et helt tal.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Mængden må ikke være mindre end antal udstyrsenheder, der er ude af drift.",
    "out_of_service_value_should_be_a_number": "Værdien for ude-af-drift skal være et tal.",
    "out_of_service_cannot_be_negative": "Ude-af-drift må ikke være negativ",
    "out_of_service_equipments_qty": "Udstyr, der er ude af drift, må ikke overstige den faktiske mængde udstyr.",
    "out_of_service_whole_number": "Ude-af-drift skal være et helt tal.",
    "slot_duration_required": "Tidsrummets varighed er påkrævet.",
    "slot_duration_integer": "Tidsrummets varighed skal være et helt tal.",
    "meeting_duration_validation": "Mødets varighed skal være mellem 1 min. og 12 t.",
    "seats_class_required": "Pladser pr. klasse er påkrævet.",
    "seats_class_integer": "Pladser pr. klasse skal være et helt tal.",
    "seats_class_validation": "Dette må ikke være større end 9999 eller mindre end 0.",
    "meeting_location_required": "Mødested er påkrævet.",
    "meeting_location_empty": "Indtast en værdi for alle placeringstyper.",
    "meeting_location_duplicate": "Duplikering af en værdi for samme lokationstype er ikke tilladt.",
    "meeting_location_booker_multiple": "Ask the Booker er ikke tilladt for flere teammedlemmer."
  },
  "custom_values": {
    "assigned_user": "Tildelt bruger",
    "full_name": "Fulde navn",
    "first_name": "Fornavn",
    "last_name": "Efternavn",
    "email": "E-mail",
    "phone": "Telefonnummer",
    "twilio_phone": "Twilio-telefon",
    "account": "Konto",
    "name": "Navn",
    "full_address": "Adresse",
    "city": "By",
    "state": "Stat",
    "country": "Land",
    "postal_code": "Postnummer",
    "contact": "Kontakt",
    "address1": "Adresse 1",
    "timezone": "Tidszone",
    "user": "Bruger",
    "appointment": "Aftale",
    "start_date_time": "Startdato",
    "start_date": "Startdato",
    "start_time": "Starttid",
    "end_date_time": "Slutdato og -tidspunkt",
    "end_date": "Slutdato",
    "end_time": "Sluttid",
    "meeting_location": "Mødested"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "lc_meet": "Mødelokale",
    "phone": "Telefonnummer",
    "full_address": "Adresse",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Tilpasset"
  },
  "duration_units": {
    "minutes": "Minutter",
    "hours": "Timer"
  },
  "widget_styles": {
    "classic": "Klassisk",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Servicemenu",
    "rooms": "Rum",
    "equipments": "Udstyr"
  },
  "lsa": {
    "categories": {
      "accountant": "Bogføring",
      "acupuncturist": "Akupunktur",
      "air_duct_cleaner": "Rensning af ventilationskanaler",
      "alcohol_treatment": "Behandling af alkoholisme",
      "animal_shelter": "Dyreredningstjenester",
      "appliance_repair": "Reparation af apparater",
      "architect": "Arkitektur",
      "assisted_living": "Plejehjem",
      "babysitter": "Børnepasning",
      "bankruptcy_lawyer": "Konkurslovgivning",
      "beauty_school": "Skønhedsskole",
      "business_lawyer": "Erhvervsret",
      "car_repair": "Bilservice",
      "carpenter": "Tømrerarbejde",
      "carpet_cleaning": "Tæpperens",
      "child_care": "Børnepasningstjenester",
      "chiropractor": "Kiropraktiske tjenester",
      "cleaning_service": "Rengøring af hus",
      "contract_lawyer": "Kontraktlovgivning",
      "countertop_pro": "Bordpladeservice",
      "criminal_lawyer": "Strafferet",
      "dance_instructor": "Danseinstruktion",
      "disability_lawyer": "Handicaplovgivning",
      "driving_instructor": "Køreundervisning",
      "dui_lawyer": "Lov om spirituskørsel",
      "electrician": "Elektrisk",
      "energy_efficiency_pro": "Energieffektivitetstjenester",
      "estate_lawyer": "Ejendomsret",
      "event_planner": "Eventplanlægning",
      "family_lawyer": "Familieret",
      "fencing_pro": "Indhegning",
      "financial_planner": "Finansiel planlægning",
      "first_aid_trainer": "Førstehjælpskurser",
      "flooring_pro": "Gulvbelægning",
      "foundation_pro": "Fundamenter",
      "funeral_home": "Begravelsestjenester",
      "garage_door_pro": "Garageport",
      "general_contractor": "Boligrenovation",
      "handyman": "Handyman",
      "home_inspector": "Inspektion af hjemmet",
      "home_security": "Sikkerhedstjenester i hjemmet",
      "home_theater": "Hjemmebiograftjenester",
      "hvac": "HVAC",
      "immigration_lawyer": "Immigrationslov",
      "interior_designer": "Indretningsdesign",
      "ip_lawyer": "Intellektuel ejendomsret",
      "junk_removal": "Fjernelse af affald",
      "labor_lawyer": "Arbejdsret",
      "landscaper": "Landskabsdesign",
      "language_instructor": "Sprogundervisning",
      "lawn_care": "Plænepleje",
      "litigation_lawyer": "Retssager",
      "locksmith": "Låsesmed",
      "malpractice_lawyer": "Lov om fejlbehandling",
      "massage_center": "Massagebehandlinger",
      "massage_school": "Massageskole",
      "mover": "Flytter",
      "nursing_home": "Plejehjemsservice",
      "painter": "Maleri",
      "personal_injury_lawyer": "Lov om personskade",
      "personal_trainer": "Personlig træning",
      "pest_control": "Skadedyrskontrol",
      "pet_adoption": "Kæledyrsadoptionstjenester",
      "pet_boarding": "Dyrepension",
      "pet_grooming": "Kæledyrspleje",
      "pet_trainer": "Kæledyrstræning",
      "photographer": "Fotografi",
      "plumber": "Blikkenslagerarbejde",
      "pool_cleaner": "Poolrensning",
      "pool_contractor": "Poolentreprise",
      "preschool": "Indskoling",
      "psychologist": "Psykologarbejde",
      "real_estate_agent": "Ejendomsbranchen",
      "real_estate_lawyer": "Ejendomsret",
      "rehab": "Rehabiliteringstjenester",
      "roofer": "Tagdækning",
      "sewage_pro": "Kloakservice",
      "siding_pro": "Beklædning",
      "smart_home": "Smart Home-serviceydelser",
      "snow_removal": "Snerydningstjenester",
      "spa": "Spa-behandlinger",
      "tax_lawyer": "Skatteret",
      "tax_specialist": "Skattetjenester",
      "therapist": "Terapi",
      "towing_pro": "Vejhjælp",
      "traffic_lawyer": "Færdselslov",
      "tree_service": "Træarbejde",
      "tutor": "Undervisning",
      "upholstery_cleaner": "Rengøring af møbelbetræk",
      "veterinarian": "Dyrlægeydelser",
      "videographer": "Videotjenester",
      "water_damage": "Service til vandskader",
      "weight_loss_service": "Vægttab",
      "window_cleaner": "Vinduespudsning",
      "window_repair": "Vinduesservice",
      "windshield_repair_pro": "Autoglas",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Andet",
      "bankruptcy_tax_litigation": "Retssager om konkurs og skat",
      "bookkeeping": "Bogføring",
      "business_consulting": "Virksomhedsrådgivning",
      "debt_collection_relief": "Inkassohjælp",
      "irs_representation_resolution": "IRS-repræsentation og -løsning",
      "payroll": "Lønningsliste",
      "tax_planning_business": "Skatteplanlægningsvirksomhed",
      "tax_planning_individual": "Skatteplanlægning for enkeltpersoner",
      "tax_return_business": "Skatteopgørelse for virksomhed",
      "tax_return_individual": "Skatteopgørelse for enkeltperson",
      "trusts_estates_accounting": "Regnskab for fonde og dødsboer",
      "acupressure": "Akupressur",
      "acupuncture": "Akupunktur",
      "acupuncturist_other": "Andet",
      "cupping": "Cupping",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Varmeterapi",
      "herbal_therapy": "Urteterapi",
      "infrared_therapy": "Infrarød terapi",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Rensning af ventilationskanaler",
      "air_duct_filter_replacement": "Filterudskiftning",
      "air_duct_other": "Andet",
      "dryer_vent_cleaning": "Rengøring af tørretumblerens udtræk",
      "furnace_cleaning": "Rengøring af fyr",
      "indoor_air_quality_testing": "Indendørs luftkvalitetstest",
      "alcohol_treatment_other": "Andet",
      "animal_shelter_cat_adoption": "Adoption af katte",
      "animal_shelter_dog_adoption": "Adoption af hunde",
      "animal_shelter_other": "Andet",
      "animal_shelter_other_animal_adoption": "Adoption af andet dyr",
      "animal_shelter_other_veterinary_services": "Andre veterinære serviceydelser",
      "animal_shelter_spay_neuter": "Sterilisering eller kastrering",
      "animal_shelter_vaccinations": "Vaccinationer",
      "lost_stray_found_animals": "Mistede, herreløse eller fundne dyr",
      "pet_license": "Kæledyrslicens",
      "pet_surrender": "Aflevering af kæledyr",
      "appliance_other": "Andet",
      "repair_dishwasher": "Reparation af opvaskemaskine",
      "repair_dryer": "Reparation af tørretumbler",
      "repair_freezer": "Reparation af fryser",
      "repair_microwave": "Reparation af mikrobølgeovn",
      "repair_oven": "Reparation af ovn",
      "repair_refrigerator": "Reparation af køleskab",
      "repair_refrigerator_freezer": "Reparation af køleskab/fryser",
      "repair_stove_cooktop": "Reparation af komfur/kogeplade",
      "repair_stove_cooktop_oven": "Reparation af komfur/kogeplade/ovn",
      "repair_washer": "Reparation vaskemaskine",
      "repair_washer_dryer": "Reparation af vaskemaskine/tørretumbler",
      "3d_architectural_rendering": "3D-arkitektonisk visualisering",
      "adaptive_reuse_historical_renovation": "Adaptiv genbrug og historisk renovering",
      "architect_other": "Andet",
      "architectural_designing": "Arkitektonisk design",
      "architectural_engineering": "Arkitektonisk ingeniørarbejde",
      "building_code_analysis_permit_coordination": "Kodeanalyse og tilladelser",
      "consulting": "Konsulenttjenester",
      "home_building_improvement": "Husbyggeri og -renovering",
      "interior_design_architect": "Indretningsdesign",
      "planning_zoning_approval_assistance": "Godkendelse af planlægning og zoneinddeling",
      "project_managing_architect": "Projektstyring",
      "site_master_planning": "Planlægning af byggeplads",
      "assisted_living_housekeeping_and_laundry": "Rengøring og vaskeri",
      "assisted_living_meal_services": "Måltidsservice",
      "assisted_living_memory_care": "Hukommelsespleje",
      "assisted_living_other": "Andet",
      "assisted_living_rehabilitation_services": "Rehabiliteringstjenester",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Wellnessprogrammer",
      "daily_living_assistance": "Hjælp til dagligdagen",
      "medication_management": "Håndtering af medicin",
      "short_term_stays": "Korttidsophold",
      "social_and_recreational_activities": "Fritidsaktiviteter",
      "babysitter_other": "Andet",
      "event_babysitting": "Børnepasning til arrangementer",
      "homework_assistance": "Lektiehjælp",
      "housekeeping_laundry": "Rengøring og vaskeri",
      "meal_preparation": "Madlavning",
      "nanny_services": "Børnepasning",
      "overnight_babysitting": "Børnepasning natten over",
      "pick_up_and_drop_off": "Afhentning og aflevering",
      "shopping_errand": "Shopping og ærinder",
      "special_needs_care": "Pleje af særlige behov",
      "virtual_babysitting": "Virtuel babysitting",
      "agriculture_bankruptcy": "Konkurs i landbruget",
      "bankruptcy_lawyer_other": "Andet",
      "bankruptcy_litigation": "Konkursretssager",
      "chapter_11_bankruptcy": "Kapitel 11 Konkurs",
      "chapter_13_bankruptcy": "Kapitel 13 Konkurs",
      "chapter_7_bankruptcy": "Kapitel 7 Konkurs",
      "corporate_bankruptcy": "Virksomhedskonkurs",
      "creditor_harassment": "Kreditorchikane",
      "debt_settlement": "Gældsafvikling",
      "foreclosure_bankruptcy_lawyer": "Tvangsauktion",
      "personal_bankruptcy": "Personlig konkurs",
      "repossession": "Tilbagetagelse",
      "wage_garnishment": "Lønudlæg",
      "beauty_school_barbering": "Barbering",
      "beauty_school_business_management": "Virksomhedsledelse",
      "beauty_school_cosmetology": "Kosmetologi",
      "beauty_school_esthetics": "Æstetik",
      "beauty_school_hair_cutting": "Hårklipning",
      "beauty_school_hair_design": "Hårdesign",
      "beauty_school_makeup": "Makeup",
      "beauty_school_massage_therapy": "Massageterapi",
      "beauty_school_nail_technology": "Negleteknologi",
      "beauty_school_other": "Andet",
      "beauty_school_retail_training": "Uddannelse i detailhandel",
      "banking_finance_law": "Bank og finansiering",
      "business_lawyer_other": "Andet",
      "business_licenses_permits": "Virksomhedslicenser og -tilladelser",
      "business_litigation": "Erhvervsretssager",
      "business_taxes": "Virksomhedsskat",
      "business_transactions_business_lawyer": "Forretningstransaktioner",
      "commercial_bankruptcy": "Erhvervskonkurs",
      "commercial_contracts_business_lawyer": "Kommercielle kontrakter",
      "employment_law_business_lawyer": "Arbejdsret",
      "incorporation_restructuring": "Selskabsdannelse og omstrukturering",
      "insurance_law": "Forsikringsret",
      "intellectual_property_law": "Intellektuel ejendomsret",
      "mergers_acquisitions_business_lawyer": "Fusioner og opkøb",
      "partnership_agreements_business_lawyer": "Partnerskabsaftaler",
      "patents_copyrights_trademarks": "Patenter, ophavsret og varemærker",
      "securities_law": "Værdipapirlovgivning",
      "shareholder_disputes": "Tvister mellem aktionærer",
      "air_and_cabin_filter": "Luft- og kabinefilter",
      "battery": "Batteri",
      "body_and_trim": "Karrosseri og udstyr",
      "brakes": "Bremser",
      "car_air_conditioning": "Aircondition",
      "car_electrical": "Elektrisk",
      "car_repair_other": "Andet",
      "check_engine_light_diagnostic": "Diagnosticering af motorlys",
      "exhaust": "Udstødning",
      "oil_change": "Olieskift",
      "steering_suspension": "Styretøj/affjedring",
      "tires": "Dæk",
      "transmission": "Gearkasse",
      "cabinetry": "Snedkerarbejde",
      "carpenter_other": "Andet",
      "decking": "Terrasse",
      "drywalling": "Gipsvægge",
      "fencing": "Indhegning",
      "general_installations": "Generelle installationer",
      "general_repairs_maintenance": "Generelle reparationer og vedligeholdelse",
      "remodeling": "Ombygning",
      "shelving_storage": "Hylder og opbevaring",
      "carpet_cleaning_other": "Andet",
      "clean_area_rugs": "Tæpperensning",
      "clean_carpet": "Tæpperensning",
      "clean_drapes_and_curtains": "Rensning af gardiner",
      "clean_upholstery": "Rengøring af polstring",
      "remove_pet_stains_and_odors": "Fjernelse af pletter og lugte fra kæledyr",
      "after_school_care": "SFO",
      "all_hours_daycare": "Døgnåben dagpleje",
      "bilingual_daycare": "Tosproget dagpleje",
      "child_care_other": "Andet",
      "drop_in_daycare": "Drop-in-børnepasning",
      "full_time_daycare": "Fuldtidsdagpleje",
      "in_home_daycare": "Dagpleje i hjemmet",
      "infant_programs": "Spædbørnsprogrammer",
      "part_time_daycare": "Deltidsdagpleje",
      "pre_kindergarten_programs": "Førskoleprogrammer",
      "preschool_programs": "Førskoleprogrammer",
      "school_age_programs": "Programmer for skolebørn",
      "special_needs_daycare": "Specialdagpleje",
      "summer_daycare": "Sommerdagpleje",
      "toddler_programs": "Programmer for småbørn",
      "weekend_daycare": "Weekendbørnepasning",
      "chiropractor_acupuncture": "Akupunktur",
      "chiropractor_chiropractic": "Kiropraktik",
      "chiropractor_massage_therapy": "Massageterapi",
      "chiropractor_other": "Andet",
      "diagnosis": "Diagnose",
      "eastern_medicine": "Østlig medicin",
      "exercise_counseling": "Træningsvejledning",
      "pain_management": "Smertehåndtering",
      "physical_therapy": "Fysioterapi",
      "spinal_adjustments": "Justering af rygsøjlen",
      "sports_medicine": "Idrætsmedicin",
      "cleaner_other": "Andet",
      "deep_clean": "Dybdegående rengøring",
      "moving_clean": "Flytterengøring",
      "office_clean": "Rengøring af kontor",
      "standard_clean": "Normal rengøring",
      "assignment_of_contract": "Overdragelse af kontrakt",
      "business_transactions_contract_lawyer": "Forretningstransaktioner",
      "commercial_contracts_contract_lawyer": "Kommercielle kontrakter",
      "contract_dispute": "Kontraktstrid",
      "contract_lawyer_other": "Andet",
      "contract_negotiation": "Kontraktforhandling",
      "contract_review": "Kontraktgennemgang",
      "employment_contracts_contract_lawyer": "Ansættelseskontrakter",
      "franchise_agreements": "Franchiseaftaler",
      "mergers_acquisitions_contract_lawyer": "Fusioner og opkøb",
      "non_disclosure_agreements_contract_lawyer": "Fortrolighedsaftaler",
      "partnership_agreements_contract_lawyer": "Partnerskabsaftaler",
      "power_of_attorney_contract_lawyer": "Fuldmagt",
      "security_agreements": "Sikkerhedsaftaler",
      "warranties": "Garantier",
      "bathroom_countertops": "Bordplader til badeværelset",
      "bathroom_wall_panels": "Vægpaneler til badeværelset",
      "countertop_design": "Bordpladedesign",
      "countertop_installation": "Montering af bordplade",
      "countertop_pro_other": "Andet",
      "fireplace_facade": "Pejsens facade",
      "granite_countertops": "Granitbordplader",
      "kitchen_countertops": "Køkkenbordplader",
      "kitchen_wall_panels": "Køkkenvægspaneler",
      "laminate_countertops": "Laminatbordplader",
      "marble_countertops": "Marmorbordplader",
      "quartz_countertops": "Kvartsbordplader",
      "remodeling_countertop_pro": "Ombygning",
      "repair_maintenance_countertop_pro": "Reparation og vedligeholdelse",
      "stone_slab_countertops": "Bordplader i sten",
      "tile_countertops": "Flisebordplader",
      "corporate_representation": "Repræsentation af virksomheder",
      "criminal_immigration_defense": "Strafferetlig forsvar i indvandringssager",
      "criminal_lawyer_other": "Andet",
      "domestic_violence": "Vold i hjemmet",
      "drug_possession": "Narkotikabesiddelse",
      "duis_reckless_driving": "Spirituskørsel og hensynsløs kørsel",
      "expungement": "Afskrivning",
      "federal_crimes": "Forbundne forbrydelser",
      "felonies": "Forbrydelser",
      "petty_crimes_misdemeanors": "Småforbrydelser og forseelser",
      "restraining_orders": "Beslaglæggelser",
      "sex_offenses": "Seksuelle overgreb",
      "three_strikes_law": "Three-strikes-lov",
      "dance_instructor_african": "Afrikansk",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Ballroom",
      "dance_instructor_belly": "Mave",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Nutidig",
      "dance_instructor_folk_traditional": "Folkemusik",
      "dance_instructor_hip_hop": "Hiphop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Børnehold",
      "dance_instructor_latin": "Latin",
      "dance_instructor_modern": "Moderne",
      "dance_instructor_other": "Andet",
      "dance_instructor_tap": "Step",
      "dance_instructor_wedding": "Bryllup",
      "disability_hearings": "Handicaphøringer",
      "disability_lawyer_other": "Andet",
      "long_term_disability": "Langtidsinvaliditet",
      "short_term_disability": "Kortvarig funktionsnedsættelse",
      "social_security_disability_insurance": "Socialsikringsforsikring for invalide",
      "ssa_claim_reconsideration": "Genovervejelse af SSA-krav",
      "ssa_disability_appeals": "SSA-ankesager om invaliditet",
      "ssa_disability_applications": "SSA-handicapansøgninger",
      "ssa_disability_benefits": "SSA-handicapydelser",
      "ssa_family_benefits": "SSA-familieydelser",
      "ssa_impairment_listings": "SSA's lister over funktionsnedsættelser",
      "supplemental_security_income": "Supplerende indkomstsikring",
      "veterans_disability_benefits": "Invaliditetsydelser til veteraner",
      "workers_compensation_disability_lawyer": "Arbejdsskadeerstatning",
      "behind_the_wheel_lessons": "Køreundervisning",
      "commercial_license_training": "Kurser i kommerciel licens",
      "defensive_driving_lessons": "Defensiv køreundervisning",
      "drivers_education_classes": "Kurser i køreundervisning",
      "driving_instructor_other": "Andet",
      "manual_transmission_lessons": "Lektioner i manuel gearskifte",
      "motorcycle_lessons": "Motorcykelundervisning",
      "traffic_school": "Trafikskole",
      "dui_dwi_dui_lawyer": "Spirituskørsel",
      "dui_injuries_dui_lawyer": "Spirituskørsel med skade",
      "dui_lawyer_other": "Andet",
      "dui_with_accident": "Spirituskørsel med ulykke",
      "felony_dui": "Grov spirituskørsel",
      "invalid_tests": "Ugyldige tests",
      "multiple_offenses": "Flere lovovertrædelser",
      "reckless_driving_dui_lawyer": "Uagtsom kørsel",
      "underage_dui": "Spirituskørsel af mindreårig",
      "electric_car_charger": "Installation af elbiloplader",
      "electrician_other": "Andet",
      "electrician_remodeling": "Ombygning",
      "install_fan": "Installation af blæser",
      "install_ground_wire": "Installation af jordledning",
      "install_light_fixtures": "Installation af lysarmaturer",
      "install_outdoor_lighting": "Installation af udendørsbelysning",
      "install_outlets_switches": "Installation af udtag eller kontakter",
      "install_security_system": "Installation af sikkerhedssystem",
      "relocate_outlets_switches": "Flytning af udtag eller kontakter",
      "repair_fan": "Reparation af ventilator",
      "repair_light_fixtures": "Reparation af lysarmaturer",
      "repair_outlets_switches": "Reparation af udtag eller kontakter",
      "repair_panel": "Reparation af panel",
      "replace_upgrade_panel": "Udskift eller opgrader panel",
      "restore_power": "Gendan strøm",
      "energy_efficiency_pro_other": "Andet",
      "charitable_giving": "Velgørenhed",
      "contests_litigation": "Strider/retssager",
      "deeds": "Skøder",
      "estate_lawyer_other": "Andet",
      "estate_planning_lawyer": "Dødsboplanlægning",
      "guardianship_estate_lawyer": "Værgemål",
      "medical_power_of_attorney": "Medicinsk fuldmagt",
      "power_of_attorney_estate_lawyer": "Fuldmagt",
      "probate_estate_lawyer": "Advokat med speciale i dødsboer",
      "trusts": "Forvaltningsformuer",
      "wills": "Testamenter",
      "anniversary_planner": "Årsdag",
      "baby_shower_planner": "Baby shower",
      "bar_and_bat_mitzvah_planner": "Bar og bat mitzvah",
      "birthday_party": "Fødselsdagsfest",
      "children_party": "Børnefest",
      "corporate_and_conference_planner": "Virksomhed og konference",
      "event_planner_other": "Andet",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religiøs begivenhed",
      "retirement_party": "Pensionsfest",
      "school_event": "Skolearrangement",
      "theme_party": "Temafest",
      "wedding_and_engagement_planner": "Bryllup og forlovelse",
      "adoption": "Adoption",
      "child_support": "Børnebidrag",
      "contested_divorce": "Omtvistet skilsmisse",
      "debt_division": "Gældsafdeling",
      "family_lawyer_other": "Andet",
      "guardianship_family_lawyer": "Værgemål",
      "mediation_family_lawyer": "Mediation",
      "modifications_of_orders": "Ændring af ordrer",
      "parent_timesharing": "Samværsordning",
      "paternity": "Faderskab",
      "prenuptial_postnuptial_agreements": "Ægtepagter og ægteskabsaftaler",
      "probate_family_lawyer": "Skifteret",
      "property_divisions": "Ejendomsafdeling",
      "protective_orders_domestic_violence_issues": "Beslaglæggelser",
      "spousal_support_alimony": "Ægtefællebidrag og underholdsbidrag",
      "uncontested_divorce": "Ubestridt skilsmisse",
      "custom_construction": "Tilpasset konstruktion",
      "fence_design": "Design af hegn",
      "fencing_other": "Andet",
      "installation_fencing_pro": "Installation af hegn",
      "repairs_maintenance_fencing_pro": "Reparation og vedligeholdelse",
      "education_savings": "Opsparing til uddannelse",
      "estate_financial_planning": "Dødsboplanlægning",
      "financial_planning": "Monetær planlægning",
      "financial_planning_other": "Andet",
      "home_purchase": "Boligkøb",
      "insurance": "Forsikring",
      "investment_advising": "Investeringsrådgivning",
      "retirement_savings": "Pensionering",
      "tax_planning": "Skatteplanlægning",
      "advanced_cardiac_life_support": "Avanceret hjerte-lungeredning",
      "aed_defibrillator": "AED - Hjertestarter",
      "basic_life_support": "Grundlæggende livredning",
      "cpr": "CPR",
      "first_aid": "Førstehjælp",
      "first_aid_trainer_other": "Andet",
      "pediatric_advanced_life_support": "Avanceret livredning til børn",
      "pediatric_cpr_first_aid": "Hjertestopbehandling og førstehjælp til børn",
      "pet_cpr_first_aid": "Hjertestop og førstehjælp til kæledyr",
      "wilderness_first_aid": "Førstehjælp i vildmarken",
      "baseboards": "Fodlister",
      "carpet": "Tæppe",
      "flooring_other": "Andet",
      "hardwood": "Hårdttræ",
      "installation_flooring_pro": "Montering af gulve",
      "marble": "Marmor",
      "polishing": "Polering af gulve",
      "refinishing": "Efterbehandling af gulve",
      "repair_maintenance_flooring_pro": "Reparation og vedligeholdelse af gulve",
      "stair_flooring": "Trappebelægning",
      "tile": "Flise",
      "wood_floor_sanding": "Slibning af trægulve",
      "basement_waterproofing": "Vandtætning af kældre",
      "crawl_spaces": "Krybekælderfundament",
      "foundation_drainage": "Dræning af fundament",
      "foundation_installation": "Installation af fundament",
      "foundation_pro_other": "Andet",
      "foundation_raising": "Forhøjelse af fundament",
      "repairs_maintenance_foundation_pro": "Reparation og vedligeholdelse",
      "slab_foundation": "Pladefundament",
      "steel_pier_pilings": "Stålpæle til moler",
      "water_moisture_control": "Vand- og fugtkontrol",
      "burials": "Begravelser",
      "caskets": "Kister",
      "cremation": "Kremering",
      "funeral_home_flowers": "Blomster",
      "funeral_home_other": "Andet",
      "funeral_home_transportation_transfers": "Transport og transfer",
      "funeral_home_veteran_services": "Veterantjenester",
      "funerals": "Begravelser",
      "gravestones": "Gravsten",
      "grief_services": "Sorgterapi",
      "memorials": "Mindehøjtideligheder",
      "urns": "Urner",
      "garage_door_other": "Andet",
      "general_maintenance": "Generel vedligeholdelse",
      "install_garage_door": "Installer garageport",
      "install_opener": "Installer åbner",
      "repair_cables": "Reparation af kabler",
      "repair_garage_door": "Reparation garageport",
      "repair_gate": "Reparation af låge",
      "repair_rollers_tracks": "Reparation af ruller og skinner",
      "replace_door_panels": "Udskiftning af dørpaneler",
      "replace_opener": "Udskiftning af åbner",
      "replace_springs": "Udskiftning af fjedre",
      "accessory_buildings": "Tilbygninger",
      "bathroom_remodel": "Renovering af badeværelse",
      "decks_patio": "Terrasser og gårdhaver",
      "exterior_finishing": "Udvendig finish",
      "foundations_concrete": "Fundamenter og beton",
      "general_contractor_commercial_projects": "Kommercielle projekter",
      "general_contractor_other": "Andet",
      "home_addition": "Tilbygning til huset",
      "home_building": "Boligbyggeri",
      "home_remodel_renovation": "Renovering og ombygning af boliger",
      "interior_finishing": "Indvendig finish",
      "kitchen_remodel": "Ombygning af køkken",
      "roofing": "Tagdækning",
      "assemble_furniture": "Samling af møbler",
      "clean_gutters": "Rengøring af tagrender",
      "handyman_other": "Andet",
      "install_drywall": "Montering af gipsvægge",
      "install_flooring": "Montering af gulv",
      "install_tile": "Montering af fliser",
      "install_water_fixtures": "Montering af vandarmaturer",
      "mount_tv": "Installation af TV",
      "paint_indoors": "Maling indendørs",
      "paint_outdoors": "Maling udendørs",
      "repair_drywall": "Reparation af gipsvæg",
      "repair_flooring": "Reparation af gulvbelægning",
      "repair_water_fixtures": "Reparation af vandarmaturer",
      "replace_tile": "Udskiftning af fliser",
      "buyer_seller_inspection": "Køber-/sælgerinspektion",
      "commercial_properties": "Kommercielle ejendomme",
      "fire_safety": "Brandsikkerhed",
      "fireplace_chimney": "Pejs og skorsten",
      "full_home_inspection": "Komplet boliginspektion",
      "home_inspector_electrical": "Elektrisk",
      "home_inspector_foundation": "Fundament",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Skimmelsvamp",
      "home_inspector_new_construction": "Ny konstruktion",
      "home_inspector_other": "Andet",
      "home_inspector_plumbing": "Blikkenslagerarbejde",
      "home_inspector_roof": "Tag",
      "home_inspector_structural": "Strukturel",
      "home_warranty": "Boliggaranti",
      "water_testing": "Vandtest",
      "well_or_septic_system": "Brønd eller septiksystem",
      "wood_insects": "Træ og insekter",
      "access_control": "Adgangskontrol",
      "alarm_systems": "Alarmsystemer",
      "commercial_security_systems": "Kommercielle sikkerhedssystemer",
      "fire_smoke_detection": "Brand- og røgdetektion",
      "home_security_doors": "Døre",
      "home_security_locks": "Låse",
      "home_security_other": "Andet",
      "home_security_windows": "Vinduer",
      "monitoring_services": "Overvågningstjenester",
      "residential_security_systems": "Sikkerhedssystemer til private hjem",
      "smart_home_integration": "Integration af Smart Home",
      "video_surveillance": "Videoovervågning",
      "audio_video_installation": "Audio- og videoinstallation",
      "commercial_projects": "Kommercielle projekter",
      "home_theater_design": "Design af hjemmebiograf",
      "home_theater_lighting": "Belysning",
      "home_theater_other": "Andet",
      "home_theater_smart_home_integration": "Integration af Smart Home",
      "install_tv": "Installation af TV",
      "network_it_services": "Netværks- og IT-tjenester",
      "outdoor_installations": "Udendørsinstallationer",
      "soundproofing": "Lydisolering",
      "whole_house_audio_video": "Audio-video i hele huset",
      "ac_maintenance": "Vedligeholdelse af klimaanlæg",
      "clean_ducts_vents": "Rengøring af kanaler og ventilationsåbninger",
      "ductless_heating_and_ac_services": "Kanalfri varme- og klimaanlægstjenester",
      "heating_maintenance": "Vedligeholdelse af varmeanlæg",
      "hvac_maintenance": "Vedligeholdelse af HVAC-anlæg",
      "hvac_other": "Andet",
      "install_ac": "Installation af klimaanlæg",
      "install_ducts_vents": "Installation af kanaler og ventilationsåbninger",
      "install_heating_system": "Installation af varmesystem",
      "install_thermostat": "Installation af termostat",
      "repair_ac": "Reparation af klimaanlæg",
      "repair_ducts_vents": "Reparation af kanaler og ventilationsåbninger",
      "repair_heating_system": "Reparation af varmesystem",
      "repair_hvac": "Reparation af HVAC",
      "repair_thermostat": "Reparation af termostat",
      "asylum": "Asyl",
      "citizenship": "Medborgerskab",
      "deportation": "Udvisning",
      "family_based_immigration": "Familiebaseret immigration",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Andet",
      "investment_visa": "Investeringsvisum",
      "outbound_work_permits": "Udgående arbejdstilladelser",
      "student_visa": "Studievisum",
      "visitor_visa": "Besøgsvisum",
      "work_visa": "Arbejdsvisum",
      "appliance_selection": "Valg af apparater",
      "cabinetry_molding_hardware_design": "Design af skabe og beslag",
      "decorating": "Dekoration",
      "door_design": "Dørdesign",
      "exterior_building_design": "Udvendigt bygningsdesign",
      "flooring_selection": "Valg af gulvbelægning",
      "interior_designer_other": "Andet",
      "landscaping_design": "Landskabsdesign",
      "lighting_design": "Belysningsdesign",
      "multifamily_housing_design": "Design af flerfamiliehuse",
      "room_planning": "Rumplanlægning",
      "stone_brick_stucco_design": "Design med sten, mursten og puds",
      "window_design": "Vinduesdesign",
      "advertisements": "Annoncer",
      "copyright": "Ophavsret",
      "export_control": "Eksportkontrol",
      "franchises": "Franchises",
      "international_ip": "International IP-adresse",
      "ip_lawyer_other": "Andet",
      "ip_strategy": "IP-strategi",
      "ip_transactions": "IP-transaktioner",
      "licensing": "Licens",
      "litigation_ip_lawyer": "Retssager",
      "non_disclosure_agreements_ip_lawyer": "Fortrolighedsaftaler",
      "patents": "Patenter",
      "technology_transfer": "Teknologioverførsel",
      "trade_secrets": "Forretningshemmeligheder",
      "trademarks": "Varemærker",
      "appliance_removal": "Fjernelse af apparat",
      "construction_waste_removal": "Bortskaffelse af byggeaffald",
      "donation_pickup": "Afhentning af donation",
      "electronic_waste_removal": "Bortskaffelse af elektronisk affald",
      "furniture_removal": "Flytning af møbler",
      "general_junk_removal": "Generel fjernelse af skrot",
      "hazardous_waste_removal": "Bortskaffelse af farligt affald",
      "house_garage_cleanout": "Rydning af hus/garage",
      "junk_removal_other": "Andet",
      "yard_waste_removal": "Bortskaffelse af haveaffald",
      "employment_contracts_labor_lawyer": "Ansættelseskontrakter",
      "employment_law_labor_lawyer": "Ansættelseslovgivning",
      "exempt_employee_status": "Status som fritaget medarbejder",
      "labor_law": "Arbejdsret",
      "labor_lawyer_other": "Andet",
      "labor_negotiations": "Lønforhandlinger",
      "privacy_rights": "Ret til privatlivets fred",
      "sexual_harassment": "Seksuel chikane",
      "unpaid_overtime": "Ubetalt overarbejde",
      "whistle_blowing": "Whistleblowing",
      "workers_compensation_labor_lawyer": "Arbejdsskadeerstatning",
      "wrongful_termination": "Uretmæssig opsigelse",
      "artificial_turf_installation": "Montering af kunstgræs",
      "concrete_masonry": "Betonmurværk",
      "driveway_landscaping": "Indkørselsarkitektur",
      "garden_decorations": "Dekorationer til haven",
      "grading_resloping": "Planering og omlægning",
      "hardscapes": "Hardscapes",
      "landscape_design": "Landskabsdesign",
      "landscape_installations": "Landskabsdesign",
      "landscaper_other": "Andet",
      "outdoor_steps": "Udendørs trin",
      "outdoor_water_feature": "Udendørs vandfunktioner",
      "paving_driveway_walkway": "Belægning af indkørsel eller gangsti",
      "retaining_walls": "Støttemure",
      "sidewalk_walkway_landscaping": "Landskabspleje af gangstier",
      "sod_seeding": "Græs og såning",
      "stone_masonry": "Stenmurværk",
      "arabic": "Arabisk",
      "english": "Engelsk",
      "french": "Fransk",
      "german": "Tysk",
      "hebrew": "Hebraisk",
      "italian": "Italiensk",
      "japanese": "Japansk",
      "korean": "Koreansk",
      "language_instructor_other": "Andet",
      "mandarin": "Mandarin",
      "portuguese": "Portugisisk",
      "russian": "Russisk",
      "sign_language": "Tegnsprog",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparation/vedligeholdelse af kunstvandingssystem",
      "lawn_care_other": "Andet",
      "lawn_mowing_maintenance": "Plæneklipning/-vedligeholdelse",
      "lawn_pest_control": "Bekæmpelse af skadedyr i plænen",
      "mulching": "Tildækning af muld",
      "seeding": "Såning",
      "sod_installation": "Udrulning af rullegræs",
      "weed_control": "Bekæmpelse af ukrudt",
      "yard_cleanup": "Oprydning af haven",
      "appeals": "Appeller",
      "case_assessment_litigation_lawyer": "Sagsvurdering",
      "civil_litigation": "Civil retssag",
      "commercial_litigation": "Kommerciel retssag",
      "contracts_and_agreements": "Kontrakter og aftaler",
      "criminal_litigation": "Kriminel retssag",
      "litigation_lawyer_other": "Andet",
      "mediation_litigation_lawyer": "Mediation",
      "settlements": "Afregninger",
      "building_lockout": "Bygningslockout",
      "copy_building_key": "Kopiér bygningsnøgler",
      "copy_vehicle_key": "Kopiér bilnøgle",
      "install_hardware": "Installer hardware",
      "locksmith_other": "Andet",
      "new_key_fob": "Ny nøglebrik",
      "rekey_lock": "Udskiftning af lås",
      "repair_hardware": "Reparation af hardware",
      "vehicle_lockout": "Låst ude af bilen",
      "consent_issues": "Samtykkeproblematikker",
      "diagnosis_errors": "Diagnosefejl",
      "malpractice_lawyer_other": "Andet",
      "medical_negligence": "Medicinsk uagtsomhed",
      "treatment_errors": "Fejl i behandlingen",
      "massage_center_other": "Andet",
      "massage_school_advanced_neuromuscular_therapy": "Avanceret neuromuskulær terapi",
      "massage_school_business_and_ethics": "Erhverv og etik",
      "massage_school_clinical_therapies": "Kliniske behandlinger",
      "massage_school_continuing_education": "Efteruddannelse",
      "massage_school_deep_tissue_massage": "Dyb vævsmassage",
      "massage_school_energetics": "Energetik",
      "massage_school_hydrotherapy": "Hydroterapi",
      "massage_school_lymphatic_massage": "Lymfemassage",
      "massage_school_online_massage_therapy": "Onlinemassageterapi",
      "massage_school_other": "Andet",
      "massage_school_prenatal_massage": "Graviditetsmassage",
      "massage_school_sports_massage": "Sportsmassage",
      "massage_school_student_massage_clinic": "Klinik for massagestuderende",
      "massage_school_swedish_massage": "Svensk massage",
      "massage_theory": "Massageteori",
      "massage_therapy_training": "Kurser i massageterapi",
      "in_state_move": "Flytning inden for staten",
      "local_move": "Lokal flytning",
      "mover_other": "Andet",
      "moving_junk_removal": "Fjernelse af affald",
      "moving_storage": "Opbevaring",
      "out_of_state_move": "Flytning uden for staten",
      "oversized_item_move": "Flytning af overdimensioneret genstand",
      "packing_unpacking": "Pakning/udpakning",
      "senior_move": "Seniorflytning",
      "vehicle_transport": "Transport af køretøjer",
      "cardiac_care": "Hjertebehandling",
      "general_medical_care": "Almen lægehjælp",
      "hospice": "Hospice",
      "iv_therapy": "IV-behandling",
      "nursing_home_meal_services": "Måltidsservice",
      "nursing_home_memory_care": "Hukommelsespleje",
      "nursing_home_other": "Andet",
      "nursing_home_pain_management": "Smertehåndtering",
      "nursing_home_rehabilitation_services": "Rehabiliteringstjenester",
      "nursing_home_wellness_programs": "Wellness-programmer",
      "outpatient_rehabilitation": "Ambulant rehabilitering",
      "post_hospital_care": "Pleje efter hospitalsindlæggelse",
      "respiratory_and_pulmonary_care": "Åndedræts- og lungepleje",
      "senior_activity_programs": "Aktivitetsprogrammer for seniorer",
      "short_term_rehabilitation": "Korttidsrehabilitering",
      "wound_care": "Sårpleje",
      "exterior_painting": "Udvendigt malerarbejde",
      "interior_painting": "Indvendigt malerarbejde",
      "paint_cabinets": "Maling af skabe",
      "paint_doors": "Maling af døre",
      "painter_other": "Andet",
      "repair_water_damage": "Udbedring af vandskade",
      "staining": "Farvning",
      "assault_battery": "Overfald og vold",
      "auto_accidents": "Bilulykker",
      "bicycle_accidents": "Cykelulykker",
      "catastrophic_injuries": "Katastrofale skader",
      "dog_bites": "Hundebid",
      "dui_injuries_personal_injury_lawyer": "Skader fra spirituskørsel",
      "medical_malpractice": "Lægefejl",
      "motorcycle_accidents": "Motorcykelulykker",
      "pain_suffering": "Smerte og lidelse",
      "pedestrian_accidents": "Fodgængerulykker",
      "personal_injury_lawyer_other": "Andet",
      "product_liability": "Produktansvar",
      "slip_fall": "Glid og fald",
      "uninsured_motorist_claims": "Krav til bilforsikring",
      "workers_compensation_personal_injury_lawyer": "Arbejdsskadeerstatning",
      "wrongful_death": "Uretmæssig død",
      "aerobics": "Aerobic",
      "athletic_performance": "Atletisk præstation",
      "circuit_training": "Kredsløbstræning",
      "endurance": "Udholdenhed",
      "fitness_assessment": "Vurdering af egnethed",
      "hiit": "HIIT",
      "nutritional_counseling": "Ernæringsrådgivning",
      "personal_trainer_other": "Andet",
      "strength_conditioning": "Styrke og kondition",
      "weight_loss": "Vægttab",
      "yoga": "Yoga",
      "ants": "Myrer",
      "bed_bugs": "Væggelus",
      "bees": "Bier",
      "cockroaches": "Kakerlakker",
      "fleas_or_mites": "Lopper eller mider",
      "hornets_or_wasps": "Gedehamse eller hvepse",
      "mosquitoes": "Myg",
      "pest_control_other": "Andet",
      "pest_inspection": "Inspektion",
      "rodents": "Gnavere",
      "spiders": "Edderkopper",
      "termites": "Termitter",
      "wildlife": "Dyreliv",
      "pet_adoption_birds": "Fugle",
      "pet_adoption_cats": "Katte",
      "pet_adoption_dogs": "Hunde",
      "pet_adoption_farm_animals": "Landbrugsdyr",
      "pet_adoption_fish": "Fisk",
      "pet_adoption_other": "Andet",
      "pet_adoption_reptiles": "Reptiler",
      "pet_adoption_small_mammals": "Små pattedyr",
      "pet_adoption_special_needs_animals": "Dyr med særlige behov",
      "cat_boarding": "Kattepension",
      "cat_grooming": "Kattepleje",
      "cat_sitting_in_home": "Kattepasning (i hjemmet)",
      "dog_boarding": "Hundepension",
      "dog_boarding_with_training": "Hundepension med kurser",
      "dog_daycare": "Dagpleje for hunde",
      "dog_grooming": "Hundesalon",
      "dog_sitting_in_home": "Hundepasning (i hjemmet)",
      "dog_training": "Hundetræning",
      "dog_walking": "Hundeluftning",
      "other_pet_boarding": "Pension til andre kæledyr",
      "other_pet_daycare": "Andet dyrepasning",
      "other_pet_grooming": "Andet kæledyrspleje",
      "other_pet_sitting_in_home": "Andet kæledyrspasning (i hjemmet)",
      "pet_boarding_other": "Andet",
      "cat_bathing": "Kattevask",
      "cat_ear_cleaning": "Rensning af katteører",
      "cat_grooming_and_styling": "Kattepleje og styling",
      "cat_nail_trimming": "Negleklipning til katte",
      "dog_anal_gland_expression": "Analkirteludtryk på hunde",
      "dog_bathing_and_blow_dry": "Hundevask og føntørring",
      "dog_ear_cleaning": "Rensning af hundeører",
      "dog_flea_and_tick_treatment": "Behandling af lopper og flåter hos hunde",
      "dog_full_service_grooming": "Hundepleje med fuld service",
      "dog_grooming_and_styling": "Hundepleje og styling",
      "dog_nail_trimming": "Klipning af hundens negle",
      "dog_teeth_brushing": "Rensning af hundetænder",
      "pet_grooming_other": "Andet",
      "aggressive_dog_training": "Træning af aggressive hunde",
      "behavior_modification": "Adfærdsændring",
      "obedience_training": "Lydighedstræning",
      "offleash_training": "Træning uden snor",
      "pet_trainer_other": "Andet",
      "puppy_training": "Hvalpetræning",
      "service_animal_training": "Træning af servicedyr",
      "sport_trick_training": "Sport- eller tricktræning",
      "training_other_animals": "Træning for andre dyr",
      "corporate_photo": "Virksomhed",
      "events_and_parties_photo": "Begivenheder og fester",
      "family_and_group_photo": "Familie og gruppe",
      "headshots_and_portraits": "Portrætbilleder",
      "individual_photo": "Individuel",
      "maternity_and_newborn_photo": "Moderskab og nyfødte",
      "photographer_other": "Andet",
      "product_photo": "Produkt",
      "real_estate_photo": "Fast ejendom",
      "school_portraits": "Skoleportrætter",
      "wedding_and_engagement_photo": "Bryllup og forlovelse",
      "find_leak": "Find og reparer læk",
      "install_faucet": "Installation af vandhane",
      "install_garbage_disposal": "Installation af affaldsdispenser",
      "install_shower": "Installation af bruser",
      "install_toilet": "Installation af toilet",
      "install_water_heater": "Installation af vandvarmer",
      "plumbing_other": "Andet",
      "repair_faucet": "Reparation vandhane",
      "repair_garbage_disposal": "Reparation af affaldskværn",
      "repair_outdoor_systems": "Reparation af udendørssystemer",
      "repair_pipe": "Reparation af rør",
      "repair_sewer": "Reparation af kloaksystem",
      "repair_shower": "Reparation af bruser",
      "repair_toilet": "Reparation af toilet",
      "repair_water_heater": "Reparation af varmtvandsbeholder",
      "unclog_drain": "Fjern tilstopning af afløb",
      "commercial_pool_cleaning_maintenance": "Rengøring og vedligeholdelse af kommercielle pools",
      "equipment_maintenance_repair": "Vedligeholdelse og reparation af udstyr",
      "one_time_pool_cleaning": "Engangsrengøring af pool",
      "ongoing_pool_cleaning": "Løbende rengøring af pool",
      "pool_cleaner_other": "Andet",
      "pool_cleaner_water_features": "Vandfunktioner",
      "seasonal_opening_closing": "Sæsonbestemt åbning og lukning",
      "spa_hot_tub_cleaning": "Rengøring af spa og boblebad",
      "spa_hot_tub_repairs": "Reparation af spa og boblebad",
      "tile_pool_wall_cleaning": "Rengøring af fliser og poolvæg",
      "water_testing_balancing": "Vandprøvning og afbalancering",
      "jetted_lap_pools": "Bassiner med boblebad",
      "pool_construction": "Opførelse af pool",
      "pool_contractor_commercial_projects": "Kommercielle projekter",
      "pool_contractor_custom_designs": "Tilpassede designs",
      "pool_contractor_other": "Andet",
      "pool_contractor_renovation": "Renovering",
      "pool_contractor_repair_cracks": "Reparation af revner",
      "pool_contractor_repair_tile": "Reparation af fliser",
      "pool_contractor_resurfacing": "Nybelæning",
      "pool_contractor_water_features": "Vandfunktioner",
      "pool_hot_tub_equipment": "Udstyr til pool og boblebad",
      "spa_hot_tub_installation": "Installation af spa og boblebad",
      "bilingual_programs": "Tosprogede programmer",
      "early_preschool": "Tidlig børnehave",
      "full_day_preschool": "Heldagsbørnehave",
      "half_day_preschool": "Halvdagsbørnehave",
      "kindergarten_classes": "Børnehaveklasser",
      "montessori_programs": "Montessori-programmer",
      "play_based_preschool": "Legebaseret børnehave",
      "preschool_infant_programs": "Spædbørnsprogrammer",
      "preschool_other": "Andet",
      "reggio_emilia_preschool": "Reggio Emilia-børnehave",
      "special_needs_programs": "Programmer for særlige behov",
      "summer_camp": "Sommerlejr",
      "waldorf_preschool": "Waldorf-børnehave",
      "psychologist_other": "Andet",
      "buyer_agent": "Købers agent",
      "first_time_home_buyer": "Førstegangskøber",
      "foreclosed_properties": "Tvangsauktionsejendomme",
      "luxury_properties": "Luksusejendomme",
      "new_construction": "Nybyggeri",
      "property_management": "Ejendomsadministration",
      "real_estate_agent_other": "Andet",
      "relocation": "Flytning",
      "rentals": "Udlejning",
      "sellers_agent": "Sælgers agent",
      "commercial_real_estate": "Erhvervsejendomme",
      "easements": "Servitutter",
      "encroachment": "Overgreb",
      "foreclosure_real_esate_lawyer": "Tvangsauktion",
      "landlord_tenant_law": "Udlejer- og lejeret",
      "litigation_real_estate_lawyer": "Retssager",
      "mortgage_lending_law": "Realkredit- og långivningslovgivning",
      "neighbor_hoa_disputes": "Tvister med naboer og boligforeninger",
      "property_damage": "Skader på ejendom",
      "purchase_agreements": "Købsaftaler",
      "real_estate_contracts_transactions": "Ejendomstransaktioner",
      "real_estate_lawyer_other": "Andet",
      "residential_real_estate": "Boligejendom",
      "title_services": "Titeltjenester",
      "trespassing": "Ulovlig indtrængen",
      "rehab_other": "Andet",
      "attic_venting": "Loftsventilation",
      "gutter_installation": "Montering af tagrender",
      "gutter_repair": "Reparation af tagrender",
      "roof_inspection": "Taginspektion",
      "roof_installation": "Montering af tag",
      "roof_repair": "Tagreparation",
      "roofer_other": "Andet",
      "skylight_installation": "Montering af ovenlysvindue",
      "skylight_repair": "Reparation af ovenlysvindue",
      "storm_wind_damage_roof_repair": "Reparation af tagskader",
      "sewage_cleaning": "Rensning",
      "sewage_excavation": "Udgravning",
      "sewage_inspection": "Inspektion",
      "sewage_installation": "Installation",
      "sewage_locating": "Lokalisering",
      "sewage_maintenance_repairs": "Vedligeholdelse og reparationer",
      "sewage_pro_other": "Andet",
      "sewage_pumping": "Pumpning",
      "sewage_removal_demolition": "Fjernelse eller nedrivning",
      "remodeling_siding_pro": "Ombygning",
      "repair_maintenance_siding_pro": "Reparation og vedligeholdelse",
      "siding_installation": "Montering af facadebeklædning",
      "siding_pro_other": "Andet",
      "siding_removal": "Fjernelse af beklædning",
      "smart_home_other": "Andet",
      "commercial_snow_removal": "Kommerciel snerydning",
      "residential_plowing": "Snerydning for private boliger",
      "residential_shoveling_blowing": "Snerydning og sneskovling for private boliger",
      "salt_sand_deicing": "Salt, sand og afisning",
      "snow_relocation": "Sneflytning",
      "snow_removal_other": "Andet",
      "body_polish": "Bodyscrub",
      "body_wrap": "Bodywrap",
      "facial": "Facial",
      "hydrotherapy": "Hydroterapi",
      "manicure": "Manicure",
      "massage": "Massage",
      "pedicure": "Pedicure",
      "peels": "Peels",
      "spa_other": "Andet",
      "spa_packages": "Spa-pakker",
      "tanning": "Solbruning",
      "waxing": "Voksning",
      "civil_tax_litigation": "Civil skatteretssag",
      "corporate_taxes": "Virksomhedsskat",
      "criminal_tax_litigation": "Strafferetlig skattesag",
      "estate_tax_planning": "Planlægning af boafgift",
      "failure_to_file": "Manglende indgivelse",
      "innocent_spouse_relief": "Hjælp til uskyldig ægtefælle",
      "international_tax_services": "Internationale skatteydelser",
      "irs_tax_problems": "Problemer med IRS-skat",
      "non_collectible_status": "Ikke-opkrævbar status",
      "offer_in_compromise": "Kompromistilbud",
      "tax_audits": "Skatterevision",
      "tax_lawyer_other": "Andet",
      "tax_liens_levies": "Skattelettelser og -opkrævninger",
      "tax_planning_lawyer": "Skatteplanlægning",
      "tax_relief": "Skattefritagelse",
      "accounting_support": "Bogføringssupport",
      "business_incorporation_restructuring": "Inkorporering og omstrukturering",
      "cryptocurrency_taxes": "Skatter på kryptovaluta",
      "irs_audit_representation": "Repræsentation ved IRS-revision",
      "irs_filing": "Indsendelse til IRS",
      "irs_problem_consulting": "Rådgivning om IRS-problemer",
      "new_business_services": "Nye forretningstjenester",
      "payroll_support": "Lønsupport",
      "tax_planning_tax_specialist": "Skatteplanlægning",
      "tax_preparation": "Skatteforberedelse",
      "tax_problem_consulting_tax_specialist": "Rådgivning om skatteproblemer",
      "tax_specialist_other": "Andet",
      "therapist_other": "Andet",
      "battery_service": "Batteriservice",
      "car_towing": "Bugsering af bil",
      "fuel_delivery": "Levering af brændstof",
      "local_hauling": "Lokal transport",
      "long_distance_hauling": "Langdistancefragt",
      "motorcycle_towing": "Bugsering af motorcykler",
      "special_vehicle_towing": "Bugsering af specialkøretøjer",
      "tire_change": "Dækskift",
      "towing_other": "Andet",
      "case_assessment_traffic_lawyer": "Sagsvurdering",
      "cdl_traffic_ticket": "Trafikforseelse ved erhvervskørekort",
      "dui_dwi_traffic_lawyer": "Spirituskørsel",
      "fixit_ticket": "Bøde for en mindre overtrædelse i forbindelse med køretøjer",
      "parking_ticket": "Parkeringsbøde",
      "reckless_driving_traffic_lawyer": "Uagtsom kørsel",
      "red_light_ticket": "Bøde for rødt lys",
      "speeding_ticket": "Fartbøde",
      "suspended_license": "Inddraget kørekort",
      "traffic_lawyer_other": "Andet",
      "traffic_ticket": "Færdselsbøde",
      "cabling_and_bracing": "Kabelføring og afstivning",
      "stump_removal": "Fjernelse af stub",
      "tree_planting": "Plantning af træer",
      "tree_removal": "Træfældning",
      "tree_service_other": "Andet",
      "tree_transplanting": "Transplantation af træer",
      "tree_trimming_and_pruning": "Beskæring og trimning af træer",
      "tutor_computer_science": "Datalogi",
      "tutor_foreign_languages": "Fremmedsprog",
      "tutor_geography": "Geografi",
      "tutor_government_and_economics": "Regering og økonomi",
      "tutor_history": "Historie",
      "tutor_homework_help": "Lektiehjælp",
      "tutor_math": "Matematik",
      "tutor_other": "Andet",
      "tutor_reading_and_writing": "Læsning og skrivning",
      "tutor_science": "Videnskab",
      "tutor_special_education": "Specialuddannelse",
      "tutor_test_pre_college_entrance": "Forberedelse til eksamen: optagelse på universitetet",
      "tutor_test_prep_grad_school_entrance": "Forberedelse til eksamen: optagelse på videregående uddannelser",
      "tutor_test_prep_k8": "Forberedelse til eksamen: K-8",
      "area_rug_cleaning": "Tæpperens",
      "drapery_and_blind_cleaning": "Rens af gardiner og persienner",
      "leather_cleaning": "Læderrens",
      "mattress_cleaning": "Madrasrens",
      "upholstery_cleaner_other": "Andet",
      "upholstery_cleaning": "Rengøring af møbelbetræk",
      "upholstery_water_damage_cleanup": "Oprydning efter vandskade",
      "bird_exotic_animal_care": "Pasning af fugle og eksotiske dyr",
      "farm_barn_animal_care": "Pasning af dyr på gården og i stalden",
      "microchipping": "Mikrochipning",
      "veterinarian_allergies": "Allergier",
      "veterinarian_behavior_counseling": "Adfærdsrådgivning",
      "veterinarian_dental_care": "Tandpleje",
      "veterinarian_dermatology": "Dermatologi",
      "veterinarian_emergency_care": "Akutbehandling",
      "veterinarian_end_of_life_care": "Pleje ved livets afslutning",
      "veterinarian_examinations": "Undersøgelser",
      "veterinarian_nutrition_counseling": "Ernæringsrådgivning",
      "veterinarian_other": "Andet",
      "veterinarian_preventive_care": "Forebyggende vedligeholdelse",
      "veterinarian_spay_neuter": "Sterilisering eller kastrering",
      "veterinarian_surgery": "Kirurgi",
      "veterinarian_vaccinations": "Vaccinationer",
      "aerial_videography": "Luftfotografering",
      "documentary_video_production": "Dokumentarproduktion",
      "family_video_production": "Produktion af familievideoer",
      "live_streaming": "Livestreaming",
      "photography": "Fotografi",
      "product_demonstrations": "Produktdemonstration",
      "promotional_video_production": "Produktion af reklamevideoer",
      "real_estate_video_production": "Videoproduktion til Ejendomsbranchen",
      "special_event_video_production": "Videoproduktion til særlige begivenheder",
      "video_editing": "Videoredigering",
      "videographer_other": "Andet",
      "voice_overs": "Voiceover",
      "wedding_video_production": "Produktion af bryllupsvideoer",
      "fire_damage_cleanup_repair": "Oprydning/reparation af brandskader",
      "water_damage_cleanup_repair": "Oprydning efter vandskade",
      "water_damage_flooring": "Gulvbelægning",
      "water_damage_mold_inspection": "Inspektion af skimmelsvamp",
      "water_damage_mold_removal": "Fjernelse af skimmelsvamp",
      "water_damage_other": "Andet",
      "water_damage_painting": "Maleri",
      "water_damage_pest_control": "Skadedyrsbekæmpelse",
      "water_damage_plumbing": "Blikkenslagerarbejde",
      "water_damage_remodeling": "Ombygning",
      "water_damage_roofing": "Tagdækning",
      "water_damage_sewage_cleanup": "Oprydning af spildevand",
      "adult_weight_loss_programs": "Vægttabsprogrammer for voksne",
      "diet_and_nutrition_counseling": "Rådgivning om kost- og ernæring",
      "kids_weight_loss_programs": "Vægttabsprogrammer for børn",
      "metabolic_testing": "Metabolisk test",
      "weight_loss_consultation_and_training": "Konsultation og kurser",
      "weight_loss_fitness_programs": "Fitnessprogrammer",
      "weight_loss_meal_planning": "Måltidsplanlægning",
      "weight_loss_personal_training": "Personlig træning",
      "weight_loss_service_other": "Andet",
      "weight_loss_wellness_programs": "Wellness-programmer",
      "glass_and_mirror_cleaning": "Rengøring af glas og spejle",
      "gutter_cleaning": "Rensning af tagrender",
      "power_pressure_washing": "Kraft-/højtryksvask",
      "rooftop_skylight_cleaning": "Vask af tagterrasse/ovenlysvindue",
      "window_cleaner_other": "Andet",
      "window_cleaning": "Vinduespudsning",
      "door_installation": "Dørinstallation",
      "door_repair": "Dørreparation",
      "glass_installation": "Glasinstallation",
      "window_boardup": "Boardup",
      "window_installation": "Montering af vinduer",
      "window_repair": "Reparation af vinduer",
      "window_repair_other": "Andet",
      "install_new_wiper_blades": "Montering af nye viskerblade",
      "repair_power_window": "Reparation af elrude",
      "repair_water_leak": "Udbedring af vandlækage",
      "repair_windshield": "Reparation af forrude",
      "replace_rear_window": "Udskiftning af bagrude",
      "replace_side_view_mirrors": "Reparation af sidespejle",
      "replace_side_window": "Udskiftning af sidespejle",
      "replace_sunroof": "Udskiftning af soltag",
      "replace_windshield": "Udskiftning af forrude",
      "windshield_other": "Andet",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditation",
      "power_yoga": "Poweryoga",
      "restorative": "Genopbyggende",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Andet"
    }
  }
}
